<template>
  <div id="app">
    <div class="pin">
      <div class="protecc"></div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk1">
        <div class="col-6 case">
          <img src="./assets/img/titre-mémoire.gif" alt />
          <img src="./assets/img/bd-intro.png" alt />
        </div>
        <div>
          <img src="./assets/img/Menu.png" alt />
        </div>

        <div class="col-6 case my-5">
          <span>
            <span class="jaune">Cliquez sur un chapitre pour y accéder directement !</span> <br> <br>
            <b
              class="dark"
              v-on:click="grandun"
              style="cursor:pointer"
            >I / De quelle manière les auteurs ont-ils investi internet ?</b>
            <br />
            <br />
            <span class="bleu">
              <span v-on:click="aun" style="cursor:pointer">a/ Le développement des blogs BD</span>
              <br />
              <span v-on:click="bun" style="cursor:pointer">b/ Des blogs BD aux réseaux sociaux</span>
              <br />
              <span v-on:click="cun" style="cursor:pointer">c/ Autres plateformes</span>
              <br />
            </span>
            <br />
            <b
              class="dark"
              v-on:click="grandde"
              style="cursor:pointer"
            >II / Quelles utilisations d’internet pour les auteurs de BD ?</b>
            <br />
            <br />
            <span class="bleu">
              <span
                v-on:click="ade"
                style="cursor:pointer"
              >a/ Différents types de présences sur internet</span>
              <br />
              <span
                v-on:click="bde"
                style="cursor:pointer"
              >b/ Présentation du parcours des auteurs interviewés</span>
              <br />
              <span
                v-on:click="cde"
                style="cursor:pointer"
              >c/ Un espace de création, de promotion et de communication</span>
              <br />
            </span>
            <span class="jaune">
              <span v-on:click="unde" style="cursor:pointer">1/ Réseaux sociaux</span>
              <br />
              <span v-on:click="dede" style="cursor:pointer">2/ Plateforme vidéo/streaming</span>
              <br />
              <span v-on:click="troide" style="cursor:pointer">3/ Financement participatif</span>
              <br />
            </span>
            <br />
            <b
              class="dark"
              v-on:click="grandtroi"
              style="cursor:pointer"
            >III / L'impact d'internet sur le métier d'auteur de BD</b>
            <br />
            <br />
            <span class="bleu">
              <span
                v-on:click="atroi"
                style="cursor:pointer"
              >a/ Pourquoi des auteurs utilisent-ils internet ?</span>
              <br />
              <span
                v-on:click="btroi"
                style="cursor:pointer"
              >b/ Assurer sa présence sur internet, un deuxième travail ?</span>
              <br />
              <span
                v-on:click="ctroi"
                style="cursor:pointer"
              >c/ Un rapport aux éditeurs qui évolue ?</span>
              <br />
            </span>
            <br />
            <br />
            <b class="dark" v-on:click="conclu" style="cursor:pointer">Conclusion</b>
            <br />
            <br />
            <b class="dark" v-on:click="biblio" style="cursor:pointer">Bibliographie</b>
            <br />
            <b class="dark" v-on:click="annexes" style="cursor:pointer">Annexes</b>
            <br />
          </span>
        </div>
        <div class="position-relative mb-5">
          <img src="./assets/img/barre-jaune.png" alt />
          <img src="./assets/img/bof.png" alt="bof" />
        </div>
        <div class="col-2 my-5 position-relative">
          <img src="./assets/img/table.png" />
          <img src="./assets/img/jean-mi-intro.png" class="mintro" />
        </div>
        <div class="col-12"></div>
        <div class="col-2 mb-5">
          <img src="./assets/img/introduction-titre.png" class="imgintro" />
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk2">
        <div class="col-6 case video">
          <iframe
            width="80%"
            height="100%"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            scrolling="no"
            src="https://player.ina.fr/player/embed/DJC9602040966/1/1b0bd203fbcd702f9bc9b10ac3d0fc21/wide/1"
            allow="fullscreen,autoplay"
          ></iframe>
        </div>
        <div class="col-12"></div>
        <div class="col-6 case mb-4">
          <span>
            <b class="bleu">Ina.fr, “ 1996 : au fait, Internet, c'est quoi déjà ? ”</b>
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-6 case text-left">
          <span>
            <b>Pour commencer, qu’est ce que c’est qu’internet ?</b>
          </span>
          <br />
          <br />
        </div>

        <div class="col-12"></div>
        <div class="col-3"></div>
        <div class="col-6 text-left">
          <div class="position-absolute test"></div>
          <span
            class="sur"
          >“ Internet, appelé parfois simplement « le Net », est un système mondial de réseaux informatiques, un réseau de réseaux au sein duquel tout utilisateur doté d'un ordinateur peut, dès lors qu'il en a l'autorisation, obtenir des informations présentes sur d'autres ordinateurs (et éventuellement parler directement à leurs utilisateurs).”</span>
        </div>
        <div class="col-3 position-relative">
          <div class="bulle1 mx-3 py-3 px-2">
            <span>
              <a
                href="https://whatis.techtarget.com/fr/definition/Internet"
                target="_blank"
              >Rouse Margaret, “ Que signifie internet ? ”</a>
            </span>
          </div>
        </div>
        <div class="col-6 case text-left">
          <span>
            <br />
            <br />Pour l’aspect historique, internet a été conçu en 1969 par l’ARPA (Advanced Research Projects Agency) pour permettre aux universitaires américains de communiquer.
            <br />
            <br />La partie d'Internet que nous utilisons le plus est le World Wide Web, souvent appelé « le Web » et connu sous l'acronyme « www ». Né au début des années 1990, il permet de consulter via un navigateur des pages accessibles sur des sites. L’image de la toile d’araignée vient des hyperliens qui unissent les pages web entre elles.
            <br />Comme internet a été popularisé par l'apparition du World Wide Web, les deux sont souvent confondus si bien qu'on ne fait aujourd'hui plus vraiment la distinction dans le langage courant.
            <br />
            <br />En 2003 Dale Dougherty parle pour la première fois de web 2.0. Le terme a été par la suite popularisé par Tim O’Reilly. Le terme web 2.0 ne fait pas vraiment l'unanimité (et est aujourd'hui quelque peu désuet), mais il permet quand même de mettre en évidence certains changements du web :
            <br />
            <br />
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-3 position-relative">
          <div class="bulle2 mx-3 py-3 px-2">
            <span>
              <a
                href="http://radar.oreilly.com/2005/10/web-20-compact-definition.html"
                target="_blank"
              >O’Reilly Tim, “ Web 2.0 compact definition ? ”, 2005</a>
            </span>
          </div>
        </div>
        <div class="col-6 text-center bleu">
          <div class="position-absolute test"></div>
          <span class="sur">
            “Web 2.0 is the network as platform, spanning all connected devices; Web 2.0 applications are those that make the most of the intrinsic advantages of that platform: delivering software as a continually-updated service that gets better the more people use it, consuming and remixing data from multiple sources, including individual users, while providing their own data and services in a form that allows remixing by others, creating network effects through an “architecture of participation,” and going beyond the page metaphor of Web 1.0 to deliver rich user experiences.”
            <br />
            <br />“Le Web 2.0 est un réseau utilisé comme plateforme reliant tous les appareils connectés à internet ; les applications Web 2.0 sont celles qui utilisent cette plateforme pour se mettre à jour continuellement grâce aux utilisateurs. Au plus il y a d’utilisateurs mettant à jour le site avec leurs données aux sources multiples et leurs informations personnelles, plus l’application crée un réseau d’utilisateurs se construisant autour d’une “architecture participative”, allant au-delà de ce que le Web 1.0 peut produire.”
            <br />
          </span>
        </div>
        <div class="col-3"></div>
        <div class="col-6">
          <span>
            <br />
            <br />Avec le web 2.0, on parle d’un web “collaboratif”. Les internautes, sans avoir besoin de connaissances pointues en informatique, ont accès à des outils qui leur permettent de publier des contenus numériques à travers les blogs, les wikis, les réseaux sociaux... Le web 2.0 tire parti de l’intelligence collective et considère les utilisateurs comme des co-développeurs.
            <br />
            <br />En 2018, parmi les 89% d’internautes recensés en France, 4 personnes sur 5 ont un usage
            quotidien d’internet !
          </span>
          <br />
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk3">
        <div class="col-6 my-5 graph">
          <img src="./assets/img/graph.png" />
          <span class="bleu">
            CREDOC, Enquêtes sur les “Conditions de vie et les Aspirations des Français ”, 2018
            Le document complet est disponible
            <a
              href="https://labo.societenumerique.gouv.fr/wp-content/uploads/2018/12/barometredunumerique2018.pdf"
              target="_blank"
            >ICI</a>
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left mb-3">
          <span>
            <b>Revenons-en à nos moutons (les auteurs et autrices de bd donc)</b>
          </span>
          <img src="./assets/img/mouton.png" alt="mouton" />
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left">
          <span>
            Traditionnellement, le point de contact entre les auteurs de bande dessinée et les lecteurs se fait lors de séances de dédicaces, de rencontres, de festivals,... c’est-à-dire assez occasionnellement. L’accès à internet s’étant démocratisé, et la publication de contenus rendue bien plus simple à "l’ère du web 2.0" , les auteurs de bande dessinée (comme tout le monde) ont pu s'approprier les lieux et entrer en contact avec leur public.
            <br />Dans un premier temps, nous reviendrons sur le phénomène des blogs BD et sur la manière dont ils ont impacté le monde de la bande dessinée. Nous nous intéresserons ensuite aux réseaux sociaux et à la manière dont ils se sont imposés au fil des années. Nous ferons aussi un petit tour d’horizon des plateformes utilisées par les auteurs de bande dessinée.
            <br />
            <br />Le témoignage de quatre jeunes autrices et auteurs (entre 27 ans et 33 ans) qui ont fait d’internet une composante importante de leur métier d'auteur de bande dessinée nous permettra de mettre en lumière différents aspects de leur pratique ainsi que leurs motivations.
            <br />Nous étudierons internet comme un espace de création et de promotion, mais aussi comme espace de communication avec des lecteurs, des internautes et aussi entre artistes.
            <br />
            <br />Pour finir, nous verrons quelles raisons poussent des auteurs de bande dessinée à être sur internet et quels changements cela a produit sur le métier. Les éditeurs sont eux aussi concernés par ces transformations: il s’agira de voir comment ces derniers composent avec.
            <br />
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-4 my-4">
          <img src="./assets/img/conclu-intro.png" alt />
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk4">
        <div class="col-6 mt-5 position-relative">
          <img src="./assets/img/danse-fanny-seule.gif" class="fanny1" />
          <div class="ghost">
            <img src="./assets/img/danse-fanny-seule.gif" />
          </div>
        </div>
        <div class="col-12"></div>
        <div class="col-6 mb-5">
          <img src="./assets/img/Titre-partie-1.png" alt class="partie1" />
        </div>
        <div class="col-12"></div>
        <div class="col-6">
          <img src="./assets/img/blogospherecoupé.jpg" alt />
          <br />
          <br />
          <span class="bleu">
            Ronzeau Romain « hommage à la blogosphère » (extrait), 2009.
            Bande dessinée complète à lire sur son blog : « Comme des guilis.com»
            <a
              href="http://commedesguilis.blogspot.com/2009/05/hommage-la-blogosphere.html"
              target="_blank"
            >http://commedesguilis.blogspot.com/2009/05/hommage-la-blogosphere.html</a>
          </span>
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk5">
        <div class="col-3"></div>
        <div class="col-6 text-left mt-5">
          <span>
            <h5 class="bleu">a/ Le développement des blogs BD</h5>
            <br />D’après Wikipedia (une source sûre), un blog est “un type de site web — ou une partie d'un site web — utilisé pour la publication périodique et régulière d'articles personnels, généralement succincts, rendant compte d'une actualité autour d'un sujet donné ou d'une profession. À la manière d'un journal intime, ces articles ou « billets » sont typiquement datés, signés et présentés dans un ordre antéchronologique, c'est-à-dire du plus récent au plus ancien.”
            <br />
            <br />Le terme “blog” provient de la contraction du terme web et log (le mot “log” pouvant être traduit par “journal de bord”). Il existe des blogs de toute sorte mais nous nous focaliserons sur les blogs BD, apparus dans les années 2000. Au début, ceux-ci étaient assez confidentiels et les auteurs de la blogosphère étaient souvent amenés à se connaître, voire à se rencontrer. Cette complicité entre les auteurs se matérialise entre autres par les liens hypertextes menant vers les blogs des uns les autres.
            <br />A partir de 2005 le nombre de blogs BD a fortement augmenté ainsi que leur audience, constituée à la fois d’amateurs de BD mais aussi plus largement d’internautes. Julien Baudry parle même d’un
            <span
              class="sur"
            >“mouvement des blogs bd” qui “devient une véritable catégorie de contenu en ligne, identifié comme tel à la fois par les amateurs de bande dessinée et par les internautes”.</span> Une deuxième génération de blogueurs BD voit ainsi le jour, et avec pour certains l’ambition de se faire connaître en tant qu’auteur. Les blogs BD sont en effet tenus en partie par des professionnels, mais on y retrouve aussi de nombreux amateurs et auteurs en voie de professionnalisation. C’est aussi en 2005 que le premier blog BD a été publié par un éditeur en version papier
            <span
              class="sur"
            >(Le blog de Frantico, réalisé par un auteur à l’identité secrète, qui n’est en fait autre que Lewis Trondheim ).</span> A partir de là, le blog BD apparaît comme un tremplin possible vers l’édition, alors que les contenus des blogs n’étaient pas pensés par leurs créateurs pour être publiés. Ce n’est qu’une minorité d’auteurs de blogs BD qui seront publiés de cette manière mais cela implique de gros changements : des éditeurs s'intéressent aux blogs BD, et ces mêmes blogs peuvent permettre à des auteurs amateurs de se lancer, de se faire connaître. Beaucoup de jeunes auteurs en voie de professionnalisation ouvrent alors un blog et se constituent ainsi une audience.
          </span>
        </div>
        <div class="col-3 position-relative">
          <div class="bulle3 mx-3 py-3 px-2">
            <span>
              <a
                href="http://neuviemeart.citebd.org/spip.php?article395"
                target="_blank"
              >Baudry Julien,” Histoire de la bande dessinée numérique française, partie 3 : les blogs bd, une spécificité française ? “, 2012.</a>
            </span>
          </div>
          <div class="bulle4 mx-3 py-3 px-2">
            <span>Pour avoir l’histoire complète, allez lire l’article de la note précédente (juste au-dessus là)↑</span>
          </div>
        </div>
        <div class="col-12"></div>
        <div class="col-2 my-5">
          <img src="./assets/img/fanny allongée.png" alt />
        </div>
        <div class="col-12"></div>
        <div class="col-4 text-left">
          <span>
            Julien Baudry catégorise plusieurs tendances au sein des blogs bd, qui peuvent évidemment se mélanger. Le blog BD peut ainsi être un espace pour diffuser un webcomic, servir de carnet de croquis virtuel, publier des dessins d’humour, partager des opinions, être un blog bd thématique (par exemple un blog de reportage bd). Mais la forme de blog la plus courante est celle de type journal intime, qui présente souvent des anecdotes tirées du quotidien de l’auteur. Ce format s’adapte bien aux publications qui doivent être brèves. Dans ce dernier cas, l’auteur se met souvent lui-même en scène dans ses bd sous la forme d’un avatar. Une des particularités des blogs est de pouvoir jouer sur la limite entre fiction et réalité. Le contenu qui y est publié est souvent spontané et s’inscrit donc dans un contexte précis à un moment précis de la vie du blogueur. Il y a une idée d'éphémère derrière ces publications qui s'enchaînent les unes après les autres pour former des strates d’archives que seuls les nostalgiques ou les grand curieux sont prêts à aller déterrer. Le blog de Lewis Trondheim illustre bien à sa manière cette idée : plus les publications sont anciennes, plus celles-ci deviennent transparentes jusqu'à s’effacer complètement.
            <br />
            <br />Les blogs offrent un espace individualisé (parfois partagé entre plusieurs artistes) que les auteurs sont libres d’alimenter quand ils veulent et avec ce qu’ils veulent. Il est possible d’y partager des dessins, des photos, des vidéos, de la musique,... De plus, l’espace commentaires ouvre une possibilité de communiquer avec des lecteurs et autres auteurs. L’auteur, habituellement peu en contact avec ses lecteurs apparaît ici comme abordable. Le lien avec les lecteurs est assez particulier parce qu'un blog n’existe réellement que s'il est consulté. Ce sont les lecteurs qui lui permettent de vivre.
            Le blog peut être un lieu de contact en plus d’un outil d’expression.
            <br />
            <br />Julien Baudry met l’accent sur une particularité très spécifique aux auteurs publiant sur internet, et qui sera un des points centraux de ce mémoire :
            <br />
            <br />
            <b>“Le rapport au blog bd n’est pas un rapport d’un lecteur à une œuvre, mais d’un lecteur à un auteur.”</b>
            <div class="text-right mt-5">
              <br />
              <span class="bleu">
                “ Les petits riens “, le blog de Lewis Trondheim.
                <a
                  href="https://www.lewistrondheim.com/blog/"
                  target="_blank"
                >https://www.lewistrondheim.com/blog/</a>
              </span>
            </div>
          </span>
          <br />
        </div>
        <div class="col-2">
          <img src="./assets/img/blog trondheim.jpg" alt />
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk6">
        <div class="col-6 mt-5">
          <span>
            <h4 class="bleu text-left">b/ Des blogs BD aux réseaux sociaux</h4>
            <br />
            <img src="./assets/img/date-insta.png" alt />
            <br />
            <br />Aujourd’hui (en 2019), les blogs BD sont de plus en plus désertés, voir abandonnés. Les réseaux sociaux occupent maintenant une place centrale. Mais pourquoi donc ?
            <br />
            <br />
            <div class="text-left">
              <span>Les médias sociaux comme les blogs ou encore les forums ont comme particularité de permettre à tous ceux qui le désirent de partager du contenu. Contrairement aux médias comme la télévision ou la radio, ceux-ci ne s'adressent pas à un public ciblé, car tout le monde peut y jouer le rôle du public ou du diffuseur. Les réseaux sociaux sont une catégorie de médias sociaux. Les réseaux sociaux fonctionnent aussi sur le partage de contenu, mais ces derniers sont focalisés sur l’interaction entre internautes et sur la création de communautés.</span>
            </div>
          </span>
        </div>
        <div class="col-12 my-3"></div>
        <div class="col-3 position-relative">
          <div class="bulle5 mx-3 py-3 px-2">
            <span>
              <a
                href="https://www.stedavies.com/social-media-algorithms-guide/#Facebook_Algorithm"
                target="_blank"
              >Analyse de l’algorithme de Facebook par Ste Davies</a>
            </span>
          </div>
        </div>
        <div class="col-6 text-left">
          <span>
            Toute l’ergonomie des réseaux sociaux est travaillée pour être la plus agréable possible. L’idée d’être récompensé pour ses publications en likes et commentaires est encore plus poussée que sur les blogs. Elle est même matérialisée visuellement par des symboles comme le coeur (sur Instagram ) ou encore le pouce vers le haut (Facebook).
            <br />De plus, les réseaux sociaux sont pensés de sorte que l’utilisateur ait le moins possible envie et besoin de sortir de la plateforme : sur le feed de Facebook se côtoient pêle-mêle des infos sur l’actualité, des illustrations des artistes suivis, les dernières photos de vacances de ses amis,... Tout est regroupé au même endroit.
            <span
              class="sur"
            >Sur facebook, l'algorithme offre plus de visibilité aux contenus partagés en natif</span> ,c’est-à-dire hébergés directement sur Facebook, et non par un autre site, ce qui pousse les utilisateurs à publier leur contenu directement sur la plateforme.
            <br />
            <br />Dans ce même principe de fonctionnement en vase clos, on ne peut partager un contenu vu sur un réseau social que sur ce même réseau. De manière plus radicale, Instagram ne laisse pas la possibilité de partager des hyperliens (sauf un, dans la biographie de l’utilisateur….) et donc de naviguer d’un site à l’autre de cette manière.
            <br />Beaucoup de blogueurs ont ainsi dû ouvrir des profils sur les réseaux sociaux pour continuer à donner une visibilité à leur travail, ce qui a réduit l’activité sur leurs blogs. Un certain nombre d'auteurs gardent tout de même leur blog car le format des publications est moins restreint et cela permet de rassembler à un même endroit les publications disséminées sur les réseaux sociaux.
            <br />Alex Norris, auteur de “webcomic name”, exprime bien cette idée :
            <br />
            <br />
            <div class="text-center">
              <span class="bleu sur">
                "In the current era of the Internet, people read whatever is on their social media feeds, rather than going hunting for something to read on individual websites. Websites can be useful as a portfolio and collecting together links to all your various projects and social media profiles"
                <br />
                <br />“A l’ère actuelle d’internet, les gens lisent sur les réseaux sociaux tout ce qui s’affiche sur leur fil d’actualité, plutôt que d’aller eux même chercher quelque chose à lire sur les sites internet. Les sites peuvent être utiles comme portfolio et pour y rassembler les liens de ses projets et de ses réseaux sociaux.”
              </span>
            </div>
          </span>
        </div>
        <div class="col-3 position-relative">
          <div class="bulle6 mx-3 py-3 px-2">
            <span>
              <a
                href="https://issuu.com/sarjakuvakeskus/docs/makingmoneyfromwebcomics2018"
                target="_blank"
              >Webcomic friends, “Making money from webcomics“,2018,p15</a>
            </span>
          </div>
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk7">
        <div class="col-6 mt-5">
          <div class="text-left">
            <span>
              <h4 class="bleu">c/ Autres plateformes</h4>
              <br />En combinaison avec les blogs et les réseaux sociaux, toutes sortes de plateformes ont été investies par des auteurs internautes. Le tout crée un réseau complexe entre les utilisateurs.
            </span>
          </div>
          <div>
            <img src="./assets/img/outils internet utilisés par les auteurs.jpg" alt />
          </div>
          <div class="text-left">
            <span>
              <div class="bleu">
                <a
                  href="http://www.ar2l-hdf.fr/upload/medias/egbdenqueteauteurs2016.pdf"
                  target="_blank"
                >Enquête sur la situation des auteurs réalisée dans le cadre des États Généraux de la Bande Dessinée (EGBD), 2016, p30.</a>
              </div>
              <br />
              <br />Les forums, bien que leur fréquentation ait diminué, sont largement utilisés. Ils offrent un espace de discussion où les internautes peuvent s’envoyer des messages mais aussi des images. Les utilisateurs s’y rassemblent souvent autour d’une thématique ou d'un sujet. On retrouve ainsi de nombreux forums liés à la bande dessinée ou plus généralement à l'art, où il est possible de recevoir des conseils, d'échanger des références, de discuter avec des artistes,...
              <br />
              <br />Par exemple le forum dessiné propose un concept original : la communication entre les utilisateurs se fait à travers des dessins. Chacun se représente à travers un avatar pour concevoir des histoires à plusieurs ou communiquer. Le forum a été créé par Lou Lubie qui est elle-même autrice de bande dessinée.
            </span>
          </div>
          <div>
            <img src="./assets/img/forum dessiné.png" alt />
            <br />
            <span>
              <a href="https://www.forum-dessine.fr/forum" target="_blank">Le Forum Dessiné</a>
            </span>
          </div>
          <div class="text-left mt-3">
            <span>
              Un site hybride comme DeviantArt (ouvert en 2000) rassemble une communauté artistique en ligne et propose un espace personnel pour les artistes, un forum, une section commentaires pour réagir aux publications des artistes et la possibilité de suivre ses artistes préférés.
              Tumblr (lancé en 2007) est un exemple de plateforme de microblogage qui permet à chaque utilisateur de personnaliser sa page tout comme les blogs, mais qui réunit en plus toutes sortes de contenus publiés par les utilisateurs. Comme sur les réseaux sociaux, les partages et likes sont facilités.
              <br />
              <br />Toutes sortes de sites, du plus général au plus spécialisé proposent aux auteurs d’y publier leurs bandes dessinées en ligne. On y retrouve aussi souvent un espace commentaire et ou un forum lié. On y retrouve par exemple les sites : Grandpapier, Webtoon, Tapastic, Amilova, Hiveworks,...
              <br />
              <br />Internet offre une visibilité au-delà de son cercle proche, et permet d’interagir avec de parfaits inconnus et donc de développer des liens avec de nouvelles personnes.
              <br />Mark Granovetter dans « force des liens faibles » (Strength of weak ties,1973) distingue les liens forts, qui nous unissent à notre famille et nos amis proches aux liens faibles qui correspondent à un réseau plus distant et étendu. Ces liens faibles qui se développent par exemple sur internet permettent de créer des liens avec des individus qui ne partagent pas forcément les mêmes points communs ou le même environnement. Les liens faibles offrent un réseau bien plus élargi que les liens forts, et donc de nouvelles opportunités , notamment dans la recherche de travail. Les liens faibles unissent les groupes les uns avec les autres.
            </span>
          </div>
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk8">
        <div class="col-6 mt-5 position-relative">
          <img src="./assets/img/danse-jeanmi.gif" class="jeanmi1" />
          <div class="ghost">
            <img src="./assets/img/danse-jeanmi.gif" />
          </div>
        </div>
        <div class="col-12 my-3"></div>
        <div class="col-6 mb-5">
          <img src="./assets/img/partie-2.gif" alt class="partie2" />
        </div>
        <div class="col-12"></div>
        <div class="col-3"></div>
        <div class="col-6">
          <div class="text-left">
            <span>
              <h4 class="bleu">a/ Différents types de présences sur internet.</h4>
              <br />
              <br />Comme on peut s’en douter tous les auteurs n’utilisent pas internet pour les mêmes raisons et donc de la même manière.
              <br />
              <br />Les Labs Hadopi ont publié une étude nommée
              <span
                class="sur"
              >“L’auteur au temps du numérique” (2012).</span> Ils proposent quatre profils types d’auteurs en fonction de leur utilisation -ou non- d’internet dans le prolongement de leur activité d’auteurs ainsi que de leur présence plus ou moins importante en ligne. Ces observations ont été établies sur base d’un échantillon d’auteurs (romanciers, auteur de BD,...) interviewés pour cette étude, et elles peuvent être évidemment nuancées.
            </span>
          </div>
        </div>
        <div class="col-3 position-relative">
          <div class="bulle7 mx-3 py-3 px-2">
            <span>
              <a
                href="http://labs.hadopi.fr/sites/default/files/ressource/4967/files/auteurtempsnumeriqueld.pdf"
                target="_blank"
              >“L’auteur au temps du numérique” (2012)</a>
            </span>
          </div>
        </div>
        <div class="position-relative col-10 my-5">
          <img src="./assets/img/graph-lignes.png" alt />
          <img src="./assets/img/graph-orange.png" alt class="oran" />
          <img src="./assets/img/graph-bleu.png" alt class="ble" />
          <img src="./assets/img/graph-jaune.png" alt class="jau" />
          <img src="./assets/img/graph-rose.png" alt class="roz" />
        </div>
        <div class="col-6 text-left">
          <span>Nous allons nous intéresser dans ce mémoire tout particulièrement au profil de “l’auteur réseau” et “commentateur” chez les auteurs de bande dessinée. Dans ces deux cas, l’auteur est présent sur internet et y offre une véritable visibilité de son travail.</span>
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk9">
        <div class="col-3"></div>
        <div class="col-3 mb-3 mt-5">
          <img src="./assets/img/interviews.png" alt />
        </div>
        <div class="col-6"></div>
        <div class="col-6 text-left">
          <span>
            <h4 class="bleu">b/ Présentation du parcours des auteurs interviewés</h4>
            <br />J’ai choisi d’interviewer quatre jeunes autrices et auteurs qui ont tous déjà publié un livre au format papier avec des éditeurs ou en autoédition. (Attention, loin de moi l’idée qu’un auteur doit publier au format papier pour être considéré comme un professionnel !). Comme on a pu le voir précédemment, il ne faut pas faire de leur cas une généralité. Ils et elles sont très actifs sur internet pour des raisons qui leur sont propres et ils ont choisi d'intégrer internet comme partie intégrante de leur travail d’auteur et d’autrice.
            Pour commencer, il est intéressant de revenir sur leur parcours, leur background et la manière dont ils ont commencé à publier leur travail sur internet.
            <br />Les interviews complètes sont disponibles en annexe !
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-1 my-5">
          <img src="./assets/img/marie.png" alt />
        </div>
        <div class="col-5 text-left my-5">
          <span>
            <h4 class="jaune">Marie Spénale</h4>Marie est une illustratrice freelance et autrice de bande dessinée. Elle publie régulièrement des illustrations dans des magazines jeunesse et a sorti deux BD au format papier à ce jour. Son dernier projet de bande dessinée en date est un feuilleton conçu pour une lecture sur Instagram , Ete_BD (saison 3, été 2019). Elle collabore au projet en tant que dessinatrice. Elle a suivi un bac technologique art appliqué puis un DMA illustration (de son ancien nom) et pour finir une formation Multimédia aux Gobelins en alternance.
            <br />
            <br />Ses débuts sur internet !
            <br />
            <br />Marie a pris connaissance de l’existence de blogs BD à travers la rubrique “ 33 rue Carambole ” tenue par Cha, Melaka et Laurel et publié dans le journal de Spirou (en 2004/2005). Les trois autrices tenaient chacune leur blog de BD respectif, ce qui leur a permis de créer des liens et de travailler ensemble sur cette rubrique, inspirée du contenu de blogs.
            <br />Suite à cette découverte, Marie a décidé d’ouvrir son propre blog alors qu’elle était en 3ème (14-15 ans). En suivant les tendances elle y postait des BD et anecdotes mais plus majoritairement des illustrations. En 2012, elle a reçu le prix de la Révélation blog BD à Angoulême pour son blog “Les lapins roses ne courent plus dans les champs” (raccourci en llrncpdlc).
            <br />
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-1 my-5">
          <img src="./assets/img/sourya.png" alt />
        </div>
        <div class="col-5 text-left my-5">
          <span>
            <h4 class="jaune">Sourya Sihachakr</h4>Sourya est Diplômé de l’Institut Supérieur des Arts Appliqués de Paris, et de l’École des Métiers du Cinéma d’Animation Angoulême. Depuis 2013, il publie régulièrement ses bandes dessinées chez Ankama.
            <br />
            <br />Ses débuts sur internet !
            <br />
            <br />Sourya a commencé à publier son travail sur internet après son BAC (vers 18 ans). Il participait à un forum de dessin nommé “Oekaki board” ou n'importe qui pouvait poster des illustrations et recevoir des commentaires, des critiques. Une particularité du forum était la possibilité d’enregistrer le processus de dessin en accéléré, ce qui a été très instructif pour Sourya. En commençant ses études supérieures, il a décidé d’ouvrir un blog pour se motiver et s'entraîner à dessiner de manière intensive. En parallèle il participait au forum du site de cinéma d’animation Catsuka. Une importante communauté de dessinateurs y était présente ; il a pu y recevoir de nombreux conseils mais aussi commencer à se faire ses premiers contacts dans le monde professionnel. A 25 ans, il est contacté par Florent Maudoux pour travailler avec lui sur un spin off de sa BD “Freak’s Squeele” (Ankama). Le travail de Sourya avait été découvert via son blog.
            <br />
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-1 my-5">
          <img src="./assets/img/mirion.png" alt />
        </div>
        <div class="col-5 text-left my-5">
          <span>
            <h4 class="jaune">Mirion Malle</h4>Mirion est autrice de bande dessinée et dessinatrice. Après deux ans de prépa lettres et une L3 d'études théâtrales à la Sorbonne, elle a passé un bachelor de bande dessinée à l'ESA St-Luc à Bruxelles. Elle a ensuite été diplômée d’une maîtrise de sociologie spécialité études de genre/études féministes entre Paris 7 et l'UQAM, à Montréal.
            <br />
            <br />Ses débuts sur internet !
            <br />
            <br />Mirion Malle a commencé à publier son travail sur un forum de dessin assez jeune, ce qui lui a permis d’entrer en contact avec d’autres artistes. C’est en prépa lettres qu’elle a commencé à publier sur son blog, “Commando Culotte”. Ce blog a suivi ses évolutions : au début il s’agissait surtout d’anecdotes pour ses amis, puis une fois arrivée à Saint-Luc elle y a publié ses travaux et expérimentations réalisés durant le cursus. Aujourd'hui, elle utilise son blog pour parler de films, de séries et de féminisme sous forme de courtes bandes dessinées didactiques. Elle a développé ces thématiques petit à petit ; elles ont évolué au fil du temps. Ces petites bandes dessinées ont suscité beaucoup de réactions et de partages par les lecteurs et de fil en aiguille ont été relayées par divers sites internet (dont mademoiZelle par exemple). Son blog a ainsi rencontré le succès et elle a été contactée par deux éditeurs pour publier au format papier son travail. Mais l’un voulant lisser le propos féministe et l’autre changer entièrement les dessins, Mirion a refusé les offres. Elle a été finalement contactée par le directeur de la collection Label 619 chez Ankama, qui lui a laissé carte blanche. Mirion n’avait pas prévu de publier un jour ses bandes dessinées de blog au format papier. En parallèle avec ses contrats d’édition et son blog, elle autoédite régulièrement ses fanzines.
            <br />
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-1 my-5">
          <img src="./assets/img/aerinn.png" alt />
        </div>
        <div class="col-5 text-left my-5">
          <span>
            <h4 class="jaune">Aerinn</h4>Aerinn est une autrice de manga qui a la particularité de s’autoéditer à grande échelle. Elle a commencé des études artistiques à l’Académie des Beaux-Arts de Tournai mais l’enseignement ne correspondant pas à ses attentes, elle a choisi de d’apprendre en autodidacte tout en exerçant simultanément un travail alimentaire.
            <br />
            <br />Ses débuts sur internet !
            <br />
            <br />Aerinn a eu réellement accès à internet à partir de 20 ans, âge auquel elle a ouvert son premier blog de dessin. En 2007 elle a crée le fanzine collectif Shinokami qui a été récompensé du prix du meilleur fanzine par Japan Touch en 2008, puis Japan Expo en 2009 et 2013. Cela a permis à Aerinn de se lancer comme professionnelle indépendante. Ses dossiers d’édition n’étant pas retenus par les éditeurs, elle a alors décidé de se lancer dans le webcomic en publiant son manga “Chronoctis Express” en 2014. Son manga est disponible à la lecture sur Amilova, feu Inkblazers en anglais, Mangadraft, Tapas, et enfin Line Webtoon. Son but était alors d’essayer de se faire remarquer par des éditeurs pour publier son histoire. N’ayant pas eu de retours malgré le succès qu’elle a rencontré auprès des lecteurs, elle a décidé de s’autoéditer en passant par le financement participatif. Elle a depuis imprimé et vendu plusieurs milliers d’exemplaires de son premier tome. Elle a réalisé un deuxième crowdfunding pour le second tome et compte continuer de cette manière.
          </span>
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk10">
        <div class="col-6 text-left">
          <span>
            <h4 class="bleu">Observations :</h4>
            <br />Ces auteurs et autrices ont des parcours et un rapport à internet très différent.
            On remarque que le mouvement des blogs BD a eu une véritable influence sur la génération d’auteurs qui a suivi. Mirion et Marie (et bien d’autres) ont toutes deux ouvert leur blog en prenant modèle sur leurs prédécesseurs. Elles ont utilisé ce support chacune à leur manière et ont ainsi acquis une visibilité auprès des internautes avant même d’avoir fini leurs études.
            <br />
            <br />Le cas de Mirion Malle dont le blog a été repéré par des éditeurs pour être publié au format papier reste une exception. En effet le contenu de son blog réunit des conditions très spécifiques : il y a une ligne directrice affirmée, une cohérence au niveau du propos et du dessin et ses publications sont facilement transposables sur le papier (il n’y a pas d’utilisation d'éléments spécifiques au format numérique, comme les gifs par exemple). De plus, son blog est connu dans le monde de la blogosphère et possède une importante audience, ce qui n’a pas dû échapper aux éditeurs. Pour donner une exclusivité aux personnes qui payent la bande dessinée papier car, rappelons-le, son contenu est disponible gratuitement à la lecture sur son blog, certaines planches ont été retravaillées et des chapitres ajoutés.
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-5 my-5">
          <img src="./assets/img/commando culotte présentation.png" alt />
        </div>
        <div class="col-12"></div>
        <div class="col-3"></div>
        <div class="col-6 text-left">
          <span>
            Un point commun à Sourya, Mirion et Marie est l’utilisation précoce d’internet pour présenter leur travail. Les forums de dessins et les blogs leur ont permis d’établir un contact avec d’autres dessinateurs dans un premier temps. Au fil des années, et en se professionnalisant, de futurs collègues auteurs et des professionnels du monde de l’édition ont pu prendre connaissance de leur travail sur le web. Ils et elles se sont créé un réseau en partie grâce à internet. L’intégration d’une école d’art participe aussi à la constitution de ce réseau complexe.
            <br />Aerinn de son côté a eu accès à internet relativement tard. Elle s’est au fil des années constitué un large lectorat en publiant son travail sur de nombreuses plateformes de webcomic (francophones et anglophones). Ayant une bonne expérience dans le milieu du fanzinat, c’est surtout en participant à des festivals qu’elle a rencontré d’autres auteurs et autrices. Il est intéressant de remarquer que le milieu dans lequel évolue Aerinn est assez différent de celui de Marie et Mirion. En france et en Belgique, le public amateur de mangas (qui peut bien évidemment apprécier les BD) est souvent par extension intéressé par la culture et les productions japonaises dans ses différents aspects. Ces personnes partagent donc des intérêts communs et peuvent se rassembler dans les nombreux festivals dédiés à leur passion qui ont vu le jour depuis les années 2000. Des auteurs comme Aerinn prennent ainsi l’habitude de promouvoir leur travail directement sur les festivals et de rencontrer leurs lecteurs.
            <span
              class="sur"
            >Ce phénomène n’a pas autant d’ampleur dans le milieu de la bande dessinée.</span>
            <br />
            <br />Aerinn témoigne : “ Côté festival de manga, les gens sont plus portés sur l'échange (...) puis bon... forcément, on partage beaucoup plus de choses en commun, on va parler des derniers mangas sortis, de jeux vidéo, d'animes, de dramas... Dans les festivals manga j'ai l'impression qu'on est tous comme une grande famille, j'aime beaucoup l'ambiance ! ”
            <br />
          </span>
        </div>
        <div class="col-3">
          <div class="bulle8 mx-3 py-3 px-2">
            <span>Le fait que cette culture pop japonaise ait été dévalorisée pendant tout un temps à créé des liens forts entre ses adhérents. Avec la nouvelle génération d’auteurs et d'autrices qui ont été plongés dès leur enfance dans les mangas, dessins animés, jeux vidéo, cela tend tout de même à changer.</span>
          </div>
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk11">
        <div class="col-6 text-left my-5">
          <span>
            <h4 class="bleu">c/ Un espace de création, de promotion et de communication</h4>
            <br />Nous allons maintenant nous concentrer sur l’utilisation faite par Mirion, Sourya, Marie et Aerinn du web pour présenter leur travail. J’ai choisi de me focaliser sur des plateformes généralistes (et donc pas spécifiquement dédiées à la BD) utilisées par ces autrices et auteurs. Il faut donc garder en tête l’existence de forums de dessin et des sites de webcomics à côté de cela.
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-2 mb-5">
          <img src="./assets/img/jonglage.png" alt class="moyen" />
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left">
          <span>
            <h4 class="jaune">1/ Les réseaux sociaux</h4>Instagram, Facebook et Twitter sont des réseaux sociaux qui ont été largement investis par les artistes. Chacun a ses contraintes, ses codes, son public. La préférence pour un réseau plutôt qu’un autre et l'utilisation qu’un artiste en fait peut vraiment varier, mais nombre d’entre eux sont présents sur les trois à la fois. C’est le cas de nos quatre autrices et auteur.
            <br />
            <br />Ces réseaux sociaux ont comme point commun de proposer l'ouverture gratuite d'un profil individuel visible par les autres utilisateurs. Comme le nom l’indique, ces réseaux favorisent l’interaction entre les usagers et permettent de contacter des personnes déjà connues de son entourage ou de suivre des personnes avec lesquelles on a a priori aucun lien.
            <br />Dans le cas des auteurs de BD, on retrouve souvent des profils dédiés à leur travail. On discerne donc parmi leurs abonnés des amateurs de dessin de tout horizon. Mais surtout, de nombreux auteurs prennent connaissance du travail de leurs collègues de cette manière, comme Marie qui raconte à propos d’Instagram : “Je me suis fait beaucoup de connaissances parmi les auteurs. Ça m’a fait un petit réseau comme ça et même aujourd’hui, c’est principalement l’intérêt pour moi, c’est de voir le travail d’autres personnes.”
            <br />Les réseaux sociaux peuvent ainsi permettre de se faire reconnaître par ses pairs et d’entrer en contact avec eux.
            <br />
            <br />D’ailleurs beaucoup d’artistes utilisent Instagram comme un portfolio, ce qui le cas de Sourya : “ Pour tenir au courant mes lecteurs et pour donner une bonne image pour des éditeurs ou artistes qui passeraient.” Instagram est un réseau dédié au partage d'images ; d'un coup d'œil sur le profil d'artistes, on peut avoir un aperçu de leur travail. Les autrices et auteurs interviewés m'ont tous fait part de la pression qu'ils ressentent vis-à-vis des réseaux sociaux. En effet leur nombre d'abonnés est important, et chacun veille à préserver son image de professionnel. " Je sais que ça va rester et ça me stresse un peu, j’essaye de poster des choses plus propres. En fait, je sais qu’il y a des personnes pro qui vont passer dessus… " (Sourya)
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-6 my-5">
          <img src="./assets/img/instagram-montage-artistes.png" alt />
          <br />
          <span class="bleu">Comptes Instagram de Sourya, Marie Spénale, Mirion Malle et Aerinn</span>
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left">
          <span>
            Dans les blogs bd tout comme sur les réseaux sociaux on retrouve ce principe de parler en son nom. L’idée d'authenticité, d’avoir un lien de personne à personne, est quelque chose de central sur les réseaux sociaux. Instagram a par exemple développé des stories, un espace ou les images qui y sont publiées disparaissent au bout de 24h. On y retrouve donc des images plus spontanées, souvent liées au quotidien auxquelles les abonnés peuvent réagir par message. Au-delà du travail d’un artiste, les internautes suivent une personne. Le contenu publié sur les réseaux sociaux va au-delà d’une exposition du travail d’un artiste ; c’est aussi sa personnalité qui est valorisée. Dans ce sens certains auteurs en profitent pour mettre en avant leurs activités de manière plus large, tout ce qui constitue leur environnement artistique voire personnel.
            <br />
            <br />Mais de nombreux auteurs ayant connu l’heure de gloire des blogs BD comme Mirion ou Marie déplorent les échanges bien plus superficiels qui ont lieu sur les réseaux sociaux. Ceux-ci laisseraient bien moins place aux retours construits et aux discussions.
            <br />Marie ajoute :“En fait le truc des réseaux sociaux par rapport à un blog, c'est qu'il y a le partage qui compte beaucoup et que du coup quand tu postes un truc, c'est quand même dans le but que ce soit repartagé par d'autres personnes qui vont s'approprier ton propos.”
            <br />
            <br />Aerinn est elle aussi présente sur les réseaux sociaux mais de manière moins active que nos autres auteurs interviewés “Je fais de la fiction donc en théorie les gens n’ont pas à s’intéresser à moi en tant que personne ou personnage, je veux qu’on se focalise sur mes BDs”. En effet, elle publie avant tout son manga sur les plateformes de webcomics. Le contenu qu’elle partage sur les réseaux est très peu lié à elle mais plutôt à son travail. On y retrouve donc le plus souvent des actualités sur son manga.
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-2 my-5">
          <img src="./assets/img/fanny allongée.png" alt />
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk12">
        <div class="col-3"></div>
        <div class="col-6 text-left">
          <span>
            Présenter son travail en ligne peut aussi conduire à des opportunités de travail : Mirion Malle n'a jamais eu à faire de portfolio. Tous ses contrats lui ont été proposés après que son travail ait été apprécié sur internet. Elle a ainsi réalisé divers travaux d'illustration et des bandes dessinées. Sourya est dans le même cas de situation : “ Ils -les éditeurs- te contactent beaucoup sur les réseaux sociaux, je reçois des fois des mails, mais aussi des messages sur Instagram et Twitter. J’y reçois beaucoup de demandes de taf.”
            <br />
            <br />Marie Spénale, étant à la fois illustratrice et autrice de BD, porte un regard croisé sur ces deux milieux qui malgré leur porosité restent distincts. L'illustration est son activité principale car elle lui permet d’en vivre, mais les réseaux sociaux ne lui servent pas à avoir du travail dans ce domaine. D’après son expérience, les directeurs artistiques se renseignent avant tout en allant regarder ce qui se publie dans les magazines et en recevant des portfolios d’illustrateurs. Pour ce qui est du monde de la bande dessinée, ses observations ne sont pas les mêmes : “ En bande dessinée, j'ai l'impression que c'est beaucoup plus important, je vois que les gens sont plus sensibles si tu as des abonnés ou pas, parce que tu vas plus publier en tant qu'auteur.”
            <br />
            <div class="mt-5">
              <img src="./assets/img/blob 1.png" alt />
              <br />
              <span class="bleu">Alex Norris, “Webcomic name”.</span>
            </div>
            <br />

            <br />Les réseaux sociaux offrent un espace gratuit aux artistes pour présenter leur travail aux yeux de tous, mais non sans contraintes. Chaque plateforme à ses propres règles, qui de plus changent au fil des mises à jour. Cela peut impacter le format des images, la visibilité des publications, le contenu autorisé… Ces règles sont parfois volontairement floues ou non dites. Des artistes peuvent voir leur visibilité considérablement chuter en fonction de l'algorithme mis en place par la plateforme. L'algorithme de Facebook a par exemple largement été contesté ces dernières années : La portée organique d’une page Facebook (nombre total de personnes voyant les publications de la page par le biais d'une distribution non payante)
            <span
              class="sur"
            >est tombée d’une moyenne de 16% à 6,5% (une page avec 10000 abonnés ne touche que 650 d’entre eux.</span>
            <br />Des contenus sont ainsi mis en avant au dépend d’autres souvent pour des raisons pécuniaires. Les artistes sont parfois contraints de se plier aux règles imposées ou bien de migrer sur de nouvelles plateformes.
            <br />
          </span>
        </div>
        <div class="col-3">
          <div class="bulle9 mx-3 py-3 px-2">
            <span>
              <a
                href="https://www.stedavies.com/social-media-algorithms-guide/#Facebook_Algorithm"
                target="_blank"
              >Analyse de l’algorithme de Facebook par Ste Davies</a>
            </span>
          </div>
        </div>
        <div class="col-12"></div>
        <div class="col-3 mt-5 mb-3">
          <img src="./assets/img/diane1.jpg" alt />
        </div>
        <div class="col-3 mt-5 mb-3">
          <img src="./assets/img/diane2.jpg" alt />
        </div>
        <div class="col-12"></div>
        <div class="col-3">
          <img src="./assets/img/diane3.jpg" alt />
        </div>
        <div class="col-3">
          <img src="./assets/img/diane4.jpg" alt />
        </div>
        <div class="col-3 mb-5">
          <img src="./assets/img/diane5.jpg" alt />
        </div>
        <div class="col-6">
          <span>
            <a
              href="https://diane-truc.tumblr.com/post/180791511824/the-purge-selfdestroy-2018-instagram"
              target="_blank"
            >Diane Truc</a>
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left">
          <span>
            <br />
            <br />Par ailleurs, les créateurs publiant du contenu militant comme Mirion Malle doivent parfois faire face aux vagues de critiques voir d’insultes et de menaces provenant d’internautes mal intentionnés. Internet permet à tous de s’exprimer et a favorisé la diffusion de la parole de militants qui n’avaient pas de place sur la scène médiatique, mais c’est aussi un porte ouverte aux propos haineux. Mirion Malle a donc choisi de passer son Twitter en privé quand leur nombre devient trop important en attendant que la situation se calme, préférant les ignorer. "En ce moment on me dit juste que mes dessins sont moches donc ça va".
            <br />Ce n’est pas une conjoncture facile à supporter pour la personne devant faire face à des propos malveillants, et il peut arriver que les évènements deviennent complètement hors de contrôle. Mirion reçoit tout de même des retours majoritairement positifs et encourageants.
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-2 my-5">
          <img src="./assets/img/télé.png" class="moyen" />
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk13">
        <div class="col-6 text-left">
          <span>
            <h4 class="jaune">2/ Les plateformes de streaming, de vidéo</h4>
            <br />
            <h5 class="bleu">YouTube</h5>Ouvert en 2005, YouTube est un site web d’hébergement de vidéos qui propose des fonctionnalités sociales (commentaires, partages,...). A priori YouTube ne concerne pas vraiment les auteurs de bande dessinée, mais cela n’a pas empêché certains comme Marie Spénale de s’y lancer. Souhaitant retrouver l’échange plus spontané qu’elle avait avec ses lecteurs quand elle tenait son blog, elle a décidé d’ouvrir sa propre chaîne dédiée à son expérience en tant qu’autrice et illustratrice.
            <br />
            <div class="mt-3">
              <img src="./assets/img/youtube marie spénale 3.jpg" alt />
            </div>
            <br />
            <a
              href="https://www.youtube.com/channel/UCpg24a2OkRJyhZhfA6jW_kw/featured"
              target="_blank"
            >Chaîne YouTube de Marie Spénale</a>
            <br />
            <br />Par rapport aux réseaux sociaux ou encore son blog, YouTube lui a apporté un nouveau public : “Avec YouTube ça a carrément changé les gens qui me suivaient ! Avant j'aurais vraiment pas parlé de communauté dans le sens ou c'était des gens qui faisaient la même chose que moi qui me suivaient... et là j'ai vachement de gens qui dessinent pas qui me suivent, ça c'est un peu nouveau.”
            <br />Sur Youtube, elle trouve que son travail à quelque chose de plus personnalisé, que le contact se fait beaucoup plus de personne à personne. Elle reçoit ainsi beaucoup de commentaires et de questions sur sa vie professionnelle, sa pratique du métier.
            <br />
            <br />Et cela a un véritable impact métier d’autrice :
            <br />“Depuis que j'ai youtube ça marche beaucoup mieux, en fait en dédicace je vois que des gens qui me connaissent via les réseaux. À Angoulême dernier, c'est un peu bizarre, tous les gens que j'ai vu en dédicace pour mon livre jeunesse, c'était des adultes qui me suivaient sur Youtube.”
            <br />Cette situation l’a poussée à se poser un bon nombre de questions : d’un part sur le public qu’elle touche avec son travail et de l’autre sa capacité à atteindre bien plus de personnes sur internet qu’en publiant ses BD au format papier.
            <br />
            <br />
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-3">
          <div class="bulle10 mx-3 py-3 px-2">
            <span>
              <a
                href="https://www.arte.tv/fr/videos/RC-014307/streamers/"
                target="_blank"
              >Tout sur les streamers avec la websérie documentaire Arte de Braun Guillaume, " Streamers " (2019)</a>
            </span>
          </div>
        </div>
        <div class="col-6 text-left">
          <span>
            <h5 class="bleu">Twitch</h5>
            <span class="sur">Twitch est une plateforme de streaming apparue en 2011.</span> Elle est issue de Justin.tv qui dès 2005 proposait différents contenus de streaming (sport, animaux, gaming, science et technologie, divertissement,...). Devant la popularité du streaming de jeux vidéo, Justin.tv ouvre Twitch pour se focaliser sur le gaming. Finalement Justin.tv a été progressivement abandonné au profit de Twitch. En 2019, Twitch compte
            <span
              class="sur"
            >4,1 millions de streamers chaque mois et une moyenne de 1.270.000 viewers (spectateurs) simultanés</span>
            , et la croissance de la plateforme est exponentielle.
          </span>
          <br />
          <br />
        </div>
        <div class="col-3">
          <div class="bulle11 mx-3 py-3 px-2">
            <span>
              <a
                href="https://twitchtracker.com/statistics"
                target="_blank"
              >Toutes les statistiques de Twitch ici</a>
            </span>
          </div>
        </div>
        <div class="col-4 text-left">
          <span>
            Twitch est donc essentiellement dédié au jeu vidéo mais il y existe une catégorie consacrée au contenu créatif. On y retrouve des dessinateurs, et donc des auteurs de BD. Ceux-ci y sont pour le moment assez peu nombreux, surtout si on s’intéresse aux artistes francophones. La plateforme attire un public assez jeune aussi bien du côté des streamers que des viewers.
            <br />Sourya a commencé à streamer en 2016. Tous ceux qui le désirent peuvent aller le voir travailler sur ses bandes dessinées au fil des jours. Comme Sourya travaille chez lui et non dans un atelier, cela lui permet d’avoir un contact avec l’extérieur. “Ça influence peut être pas vraiment sur les dessins ou l'histoire mais ça influence sur mon humeur, sur mon envie de travailler. Ça me permet d'être focus.”
            <br />Il ne streame pas toute l’année en continu comme le feraient des streameurs dont c’est le métier principal, des étapes comme le storyboard ou encore le crayonné lui demandant plus de concentration.
            <br />Sourya a toujours accordé de l’importance au lien qu’il entretient avec ses lecteurs, ses abonnés ainsi que d’autres artistes ; c’est ce qui l’a aussi poussé à ouvrir une chaîne de streaming.
            <br />Il note une véritable différence sur le contact qu’il a avec ses abonnés sur les réseaux sociaux comparé au streaming :
            <br />
            <br />“Instagram et Twitter c’est vachement plus pro et même si il y a souvent les mêmes personnes qui likent je n'ai pas l’impression ou le sentiment qu’ils sont aussi proches que mes viewers sur Twitch. Sur Twitch des fois les gens qui viennent me voir ils restent des heures, je trouve ça vraiment étonnant parce qu’il se passe rien sur mon stream!”
            <br />
            <br />
          </span>
        </div>
        <div class="col-2">
          <img src="./assets/img/sourya twitch.png" alt />
          <br />
          <div class="text-right">
            <span class="bleu">Sourya, dans «Talli fille de la lune» tome 1</span>
          </div>
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left">
          <span>
            Twitch est un lieu d’échange où les spectateurs peuvent envoyer des messages via la chatbox aux streamers ainsi qu’aux autres spectateurs. Ce qui réunit ces gens est évidemment le streamer et le contenu qu’il propose, mais aussi l’envie de communiquer et de créer des liens avec de nouvelles personnes. Le streaming sur Twitch est en effet basé sur le principe de communautés, ce qui peut donner un sentiment d’appartenance aux personnes qui s’y sont investies. Les streamers réunissent des gens de divers horizons et au fil des rendez-vous réguliers discutent un peu de tout et apprennent à se connaître.
            <br />
            <br />Sourya remarque à ce propos :
            <br />“T’as une vraie communauté qui se crée entre les auteurs déjà premièrement, mais aussi avec les viewers. C’est-à-dire que la plupart des viewers que tu vas trouver dans un stream de bd, parce que c’est vraiment un truc de niche, il y a des fortes chances que tu les trouves dans un autre stream d’auteur de bd. Du coup il a ce côté où on partage, on avance tous ensemble avec une communauté de gens qui aiment la BD.”
          </span>
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk14">
        <div class="col-5 my-5">
          <img src="./assets/img/twitch.jpg" alt />
          <br />
          <span
            class="bleu"
          >Stream d’une session de dessin organisée par Sourya avec ses viewers, pour fêter la sortie de sa nouvelle BD. En plus de créer un moment de partage, il promeut son travail.</span>
        </div>
        <div class="col-12"></div>
        <div class="col-3">
          <div class="bulle12 mx-3 py-3 px-2">
            <span>
              <a
                href="https://www.youtube.com/watch?v=SbdQiLhpONU"
                target="_blank"
              >Conseil économique social et environnemental, " Colloque " lien social et réseaux sociaux " débats de la matinée - cese " (2014)</a>
            </span>
          </div>
        </div>
        <div class="col-6 text-left">
          <span>
            Roger-Pol Droit rappelle dans un
            <span
              class="sur"
            >colloque sur le “lien social et réseaux sociaux”</span> qu’ “ il n’y a pas de véritable cassure tranchée entre réel et virtuel.”
            <br />Il y a une continuité des pratiques entre le hors ligne et en ligne : Sourya a à plusieurs reprises organisé des meet up (rencontres) dans la “vraie” vie avec ses viewers. De plus, afin de maintenir un contact avec sa communauté même en dehors des stream, il a ouvert
            <span
              class="sur"
            >un serveur Discord</span> ou les membres peuvent venir discuter.
          </span>
        </div>
        <div class="col-3">
          <div class="bulle13 mx-3 py-3 px-2">
            <span>Discord est un logiciel né en 2015 sur lequel les utilisateurs peuvent ouvrir un serveur et proposer à ceux qui le rejoignent des salons textuels et ou vocaux.</span>
          </div>
        </div>
        <div class="col-12"></div>
        <div class="col-2 my-5">
          <img src="./assets/img/oeuf.png" alt class="moyen" />
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left">
          <span>
            <h4 class="jaune">3/ Le financement participatif</h4>Beaucoup d’auteurs amateurs et professionnels passent un jour par l’autoédition pour leurs fanzines et autres publications. En autoédition, l’auteur gère toutes les étapes de production de la première esquisse à la distribution de son livre. Comme l’auteur ne passe dans ce cas pas par l'intermédiaire d’un éditeur, c’est à lui de couvrir tous les frais. Mais depuis quelques années les sites de financement participatif se sont popularisés et permettent aux auteurs de recevoir de l’argent pour leur travail directement depuis leurs lecteurs via internet. Il existe plusieurs sortes de plateformes de financement participatif.
            <br />
            <br />Des sites comme Patreon et Tipeee proposent de donner un pourboire (il s’agit souvent de petites sommes) qui peut être renouvelé chaque mois en échange de contreparties de la part de l’auteur.
            <br />Aerinn propose par exemple un accès en avant-première à ses nouvelles planches pour ses tipeurs. En fonction du montant du tip, les lecteurs peuvent avoir accès aux coulisses de son manga en découvrant ses storyboards, mais ils peuvent aussi recevoir des aquarelles originales, des illustrations numériques, interagir avec les personnages du manga, etc. Ce système permet ainsi à Aerinn de toucher chaque mois de l’argent pour pouvoir continuer à travailler sur sa bande dessinée.
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-5 mt-5">
          <img src="./assets/img/u tipeee.jpg" alt />
          <br />
          <span>
            <a href="https://fr.tipeee.com/aerinn-art">Page tipeee d’Aerinn</a>
          </span>
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk15">
        <div class="col-6 text-left">
          <span>Un autre mode de fonctionnement repose sur les campagnes de financement participatif que l’on retrouve sur des sites comme Ulule, Kickstarter, KissKissBankBank. Les créateurs y soumettent leur projet sur la plateforme ainsi qu’une somme à atteindre pour le financer. Les internautes choisissent le montant qu’ils donnent en fonction des contreparties qu’ils souhaitent recevoir. Des auteurs de BD proposent ainsi en prévente leur bande dessinée sur ces plateformes car elles leur permettent de ne pas avoir à avancer l’argent nécessaire à l’impression des livres entre autres.</span>
        </div>
        <div class="col-12"></div>
        <div class="col-5 my-5">
          <img src="./assets/img/ulule.jpg" alt />
          <br />
          <span>
            <a href="https://fr.ulule.com/chronoctis-express-tome-2/">Page Ulule d’Aerinn</a>
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-3">
          <div class="bulle14 mx-3 py-3 px-2">
            <span>Attention à ne pas se fier aux sommes parfois impressionnantes récoltées lors de crowfunding : une grande partie sert à financer l’impression des livres et des goodies, une autre les frais de de la plateforme et les envois...Si bien qu’il ne reste pas toujours beaucoup d’argent pour rémunérer l'auteur !</span>
          </div>
        </div>
        <div class="col-6 text-left">
          <span>
            Aerinn combine ainsi un tipeee et un Ulule en utilisant les caractéristiques propres à ces deux plateformes. Alors que Tipeee lui permet de toucher chaque mois un peu d’argent de la part de ses soutiens, elle utilise
            <span
              class="sur"
            >Ulule pour lancer la sortie des nouveaux tomes de sa série.</span> Ses lecteurs peuvent ainsi précommander son manga en version papier.
            Aerinn relève plusieurs points positifs à cette manière de travailler : “ L'autoédition, c'est la liberté de création, de pouvoir gérer notre temps à notre rythme, de laisser le temps à nos créations de faire leurs preuves (contrairement aux quelques jours d'existence dans les librairies). Et on gagne beaucoup plus d'argent pour beaucoup moins de livres vendus.”
          </span>
        </div>
        <div class="col-3"></div>
        <div class="col-2 my-5">
          <img src="./assets/img/jeanmi-allongé.png" alt />
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left">
          <span>
            Mais faire une campagne de financement participatif en autoédition apporte aussi son lot de difficultés. En effet, l’auteur doit assurer seul le travail normalement réalisé par un éditeur, mais aussi par le diffuseur. Aerinn a ainsi dû s’occuper de la communication sur les réseaux sociaux, de faire elle-même les devis pour choisir des imprimeurs pour ses livres et goodies, faire de la comptabilité, préparer les fichiers pour l’impression, réceptionner les livres et être en mesure de les stocker, préparer les paquets, les envoyer, contacter les libraires et leur faire les factures, vendre ses mangas en festival, ...
            <br />Aerin ajoute à ce propos : “ C'est aussi chronophage (on gère seul plusieurs métiers), du coup ça demande énormément de compétence et d'organisation, plus qu'un auteur édité. Et on est plus isolé (pas d'éditeur pour t'orienter, te rassurer, donner son point de vue...) , donc plus facilement en proie au doute. Cela dit je préfère largement l'autoédition. La liberté ça n'a pas de prix !”
            <br />De plus, avant de se lancer, il faut avoir construit au fil des années une communauté, une audience qui sera prête à soutenir le projet en le finançant ou en en faisant la promotion. Il faut donc être capable de fédérer sa communauté, mais aussi de la maintenir et de la solliciter.
            <br />
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-10 mt-3 mb-5">
          <img src="./assets/img/louise.png" alt />
          <br />
          <span>
            <a
              href="http://louisejoor.blogspot.com/2018/09/vers-une-nouvelle-aventure.html?m=1"
            >Extrait de la bande dessinée «Vers une nouvelle aventure » du blog de Louise Joor</a>
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-3"></div>
        <div class="col-6 text-left">
          <span>
            Quelques auteurs qui ont publié chez des éditeurs ont choisi de se lancer en autoédition en utilisant le financement participatif. Parmi les plus célèbres on retrouve Laurel, Maliki ou encore Yatuu, qui restent des exceptions dans le paysage de la bande dessinée. Leur succès s’explique entre autres par le fait qu’ils et elles proposent du contenu sur internet depuis longtemps (notamment à travers leurs blogs) ; leur communauté est active, la gestion de leurs crowfunding se fait en équipe ou en couple et leurs activités sont diversifiées.
            <br />
            <br />Par ailleurs, le régime de la sécurité sociale des artistes-auteurs ne reconnaît que certains types de revenus, ce qui pose problème par exemple dans le cas des dons reçus sur Tipeee qu’il faut pouvoir déclarer. Dans cette situation, les auteurs sont amenés à se confronter à des questions auxquelles ils ne sont pas formés et sensibilisés.
            <span
              class="sur"
            >Par exemple Yatuu a demandé conseil à un comptable spécialisé dans ces questions. Elle a ainsi créé sa boîte de production pour ne pas changer de régime social tout en déclarant ses revenus.</span> Cette solution lui permet de diversifier ses rentrées d’argent en gardant le statut d'auteur.
            <br />
          </span>
        </div>
        <div class="col-3">
          <div class="bulle15 mx-3 py-3 px-2">
            <span>
              <a
                href="http://jetfm.fr/site/Jet-fm-a-Angouleme-du-23-au-27.html"
                target="_blank"
              >Conférence de l’AdaBD au Festival d’Angoulême “Créer et maintenir sa communauté de lecteur(trice)s : expériences croisées” (2019)</a>
            </span>
          </div>
        </div>
        <div class="col-3">
          <div class="bulle16 mx-3 py-3 px-2">
            <span>
              <a
                href="https://www.youtube.com/watch?v=hkSpvtSyKmc"
                target="_blank"
              >La situation est expliquée par Evrard Cyrielle (Yeah Cy) dans sa vidéo " Auto-édition ; le remède miracle ? " (2019)</a>
            </span>
          </div>
        </div>
        <div class="col-3 text-left mt-5">
          <span>
            <span
              class="sur"
            >L'autoédition n'est pas une solution miracle face aux problèmes rencontrés dans le monde de l'édition traditionnelle. Maliki, dans une interview</span>
            résume bien les difficultés de cette entreprise : "Ce mode de fonctionnement est très (trop ?) particulier, et s’adresse à des auteurs qui ont envie de toucher à plein de métiers, qui ont le temps (pas d’enfants par exemple), un conjoint ou une personne pour les aider. C’est un statut qui n’offre aucune sécurité, aucune garantie, aucun filet en cas de chute, pas de système de santé, de retraite fiable…"
            <br />
            <br />Quel que soit le choix de l’auteur de travailler avec un éditeur ou en autoédition, chacune de ces voies ont leurs inconvénients et avantages. Il relève de l’auteur d’adopter le mode de fonctionnement qui lui convient le plus.
            <br />
          </span>
        </div>
        <div class="col-4 mt-5">
          <img src="./assets/img/Laurel p93 californid.jpg" alt />
          <br />
          <a
            href="https://bloglaurel.com/post/californid-la-page-93/1315"
            target="_blank"
          >Laurel, extrait de «Californid» p93</a>
        </div>
        <div class="col-2"></div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk16">
        <div class="col-2 my-5">
          <img src="./assets/img/fanny-poing.png" alt class="fanny3" />
          <img src="./assets/img/poing.png" alt class="poing" />
          <div class="ghost">
            <img src="./assets/img/fanny-poing.png" style="max-width:80%" />
          </div>
        </div>
        <div class="col-12"></div>
        <div class="col-8 mb-5">
          <img src="./assets/img/titre-partie-3.png" alt class="partie3" />
        </div>
        <div class="col-6 text-left">
          <span>
            <h4 class="bleu">a/ Pourquoi des auteurs utilisent-ils internet dans leur travail ?</h4>
            <br />Il est intéressant pour commencer de tourner la question à l'envers et de voir du côté des internautes ce qui les pousse à suivre et/ou à communiquer avec des auteurs et autrices sur internet.
            <br />
            <br />Les réponses qui suivent sont une sélection de réponses issues du sondage que j’ai proposé aux internautes. Le sondage complet est disponible en annexe.
          </span>
        </div>
        <div class="col-10">
          <img src="./assets/img/lecteurs.png" alt />
        </div>
        <div class="col-6 text-left">
          <span>
            Publier son travail sur internet est quasiment devenu la norme chez les auteurs et beaucoup d’entre eux cumulent les plateformes. Cela se vérifie surtout avec la nouvelle génération d'auteurs, qui a eu accès très jeune à internet et qui est donc de manière générale plus à l'aise avec l’utilisation et la communication sur les médias sociaux. Les jeunes auteurs touchent aussi le plus souvent des internautes de leur génération qui est aussi plus naturellement présente sur ces réseaux.
            <br />Pour Marie Spénale, "Il faut forcément avoir une présence en ligne. Ne serait-ce que pour être reconnu parmi ses pairs, pour voir ce qui se fait, que les autres voient ce que tu fais. Quand tu dessines, tu montres ton travail."
            <br />
            <br />La présence d’un auteur de bande dessinée sur internet est logique dans la continuité de son travail, de par la nature même du métier.
            <br />Le visuel est beaucoup mis en avant sur internet, il permet d’attirer l’attention et de donner envie d’en voir plus. En faisant de la bande dessinée, l’auteur possède une mine d’or de visuels à présenter, du stade de recherches et croquis aux planches finies.
            <br />
            <br />De plus, comme ce métier apparaît souvent comme solitaire, de nombreux auteurs travaillant seuls chez eux, internet permet d’échanger avec des internautes, des collègues mais aussi leurs lecteurs. N’ayant pas souvent l’occasion de rencontrer ces derniers, c’est l’outil idéal pour recueillir leurs remarques, et discuter pour ceux qui le désirent.
            <br />
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-6 my-5">
          <img src="./assets/img/lieu travail auteurs.jpg" alt />
          <br />
          <span>
            <a
              href="http://www.ar2l-hdf.fr/upload/medias/egbdenqueteauteurs2016.pdf"
              target="_blank"
            >Enquête sur la situation des auteurs a été réalisée dans le cadre des États Généraux de la Bande Dessinée (EGBD), 2016, p16.</a>
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-2">
          <img src="./assets/img/fanny allongée.png" alt />
        </div>
        <div class="col-12"></div>
        <div class="col-5">
          <img src="./assets/img/lisa mandel.jpg" alt />
          <br />
          <span class="bleu">Lisa Mandel, “ Une année exemplaire, jour 38 ”</span>
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left">
          <span>
            Avoir des retours et des encouragements sur son travail sur internet est positif à condition de ne pas s’engager dans une course aux abonnés , aux likes, aux vues,... Les récompenses y sont immédiates mais aussi éphémères et les médias sociaux sont vite addictifs. Ceux-ci mettent très en avant ces compteurs qui veulent se présenter comme un indice de l'intérêt suscité par le travail d’un artiste. Les auteurs apprennent à devenir leur propre community manager en consultant leurs statistiques (très complètes sur les réseaux sociaux), en prenant exemple sur d’autres personnes, en expérimentant. Une notoriété sur internet n’est pourtant pas synonyme d’une vie d’artiste épanouie. Cela peut-être une aide, en particulier si l’auteur concentre son activité sur internet mais ça ne permet pas forcément d’avoir une stabilité dans son travail.
            <br />
            <br />Marie Spénale relate : “Aujourd'hui il y a beaucoup de gens dans l'illustration et la BD dont les réseaux sociaux font réellement partie de l'activité. Et moi pas du tout, c'est vraiment un bonus, ça m'apporte pas de clients, enfin en BD ça m'aide peut-être à négocier des trucs. Ça m'apporte pas d'argent concrètement, c'est vraiment pour m'amuser, un peu pour faire ma promo Instagram.”
            <br />
            <br />Comme nous l’avons vu les niveaux d’implication sont très différents en fonction de la manière dont chacun envisage son activité d’auteur de bande dessinée. Internet peut simplement servir de vitrine, mais aussi être employé pour diffuser ses bandes dessinées. Il y a aussi des auteurs qui se reposent entièrement sur leur communauté par laquelle ils sont directement rémunérés. Mais de manière générale, on remarque que les auteurs utilisent internet pour mieux servir la diffusion de leur œuvre papier.
            <br />
            <br />Sur internet, et en particulier les réseaux sociaux, l'auteur en tant qu'individu est mis en avant. Ce n’est pas une situation qui convient à tout monde et qui peut même rebuter certains à s’y investir.
            <br />Marie Spénale : “Moi je reste assez centrée sur le travail mais il y a des illustratrices dont l’activité est centrée sur les réseaux sociaux et qui partagent toute leur vie. Et quand elles dessinent, elles dessinent pour les réseaux sociaux, c'est vachement plus tourné vers les gens. C'est vraiment une pratique très différente de la mienne ou moi je fais mes trucs et après je donne un aperçu de ce que je fais sur les réseaux sociaux.”
            <br />
            <br />Chaque plateforme à son propre mode de fonctionnement, et comme nous l'avons vu avec les auteurs interviewés, chacun choisit celle qui lui correspond le plus, en fonction du contenu qu'il souhaite proposer et du mode de communication qu'il désire mettre en place avec les internautes.
            <br />Les médias sociaux ont aussi tendance à créer une zone de flou entre la vie privée et publique, lié en grande partie au fait qu'un auteur n'y publie pas que son travail. Les auteurs interviewés sont d'ailleurs vigilants sur ce point. Même s’ils postent des anecdotes sur leur vie, cela reste généralement très contrôlé. Mais c'est toujours un sujet qui questionne, à l'instar de Marie Spénale qui souhaite se lancer dans les vlogs sur YouTube : "Mais dans ce genre de cas c'est hyper compliqué, elle commence et elle s'arrête ou la vie d'illustratrice et ma vie perso...C'est hyper mélangé."
            <br />Sourya, de son coté, limite les publications qui ne concernent pas directement son travail : " Ça me fait un peu peur, et j’ai pas envie qu’on me juge pour ça. Mais j’adore quand les artistes mettent autre chose que des dessins, qu’ils postent des trucs hyper intéressants. Il y a des gens qui te suivent parce qu’ils admirent qui tu es et pas juste parce qu’ils aiment bien tes dessins."
            <br />Pour les artistes militants comme Mirion Malle, partager ses réflexions et ses opinions fait pleinement partie de la démarche d'auteur, et internet est dans ce cas un très bon support de diffusion.
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-2 my-5">
          <img src="./assets/img/travail.png" alt />
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk17">
        <div class="col-3">
          <div class="bulle17 mx-3 py-3 px-2">
            <span>
              <a
                href="https://twitter.com/ohhmarion/status/978643561561362433"
                target="_blank"
              >Thread Twitter complet de Mirion Malle</a>
            </span>
          </div>
        </div>
        <div class="col-6 text-left">
          <span>
            <h4 class="bleu">b/ Assurer sa présence sur internet, un deuxième travail ?</h4>
            <br />C'était déjà le cas avant mais internet semble tout de même renforcer, ou tout du moins rendre plus visible la diversification des activités des auteurs. Il est possible de présenter publiquement ce qui est fait à côté ou en combinaison avec la bande dessinée. Quelques auteurs proposent ainsi à leur audience des vidéos, de la musique, des podcasts, du streaming, des articles … Le métier d'auteur peut aussi s’étendre hors de l'aspect artistique : Internet a cette capacité à pouvoir mettre en lien un auteur directement avec son public, sans passer par des éditeurs. Un auteur peut ouvrir sa propre boutique en ligne, être capable de manier la communication autour de son travail, de passer par le financement participatif (et donc de gérer tous ce que cela implique comme nous l'avons vu plus haut).
            <br />
            <span class="sur">
              <br />Pour revenir à l'aspect chronophage d'internet, il faut noter que le travail de communication est considérable et non rémunéré pour les auteurs. Mirion Malle évoque très bien les divers problèmes que cela peut poser, dans un milieu déjà précarisé.
              " Elles (les plateformes) sont basées sur le contenu gratuit que les artistes, entre autres, fournissent et par leurs algorithmes nous forcent en plus à nous plier à leurs demandes. On travaille gratuitement et tout ça pour des likes qui au final permettent rarement de vivre. L’ironie terrible c’est que le vrai but de ces plateformes, c’est que tu paies pour montrer le travail que t’as fait gratos sur mesure pour elles."
              <br />Et concernant les plateformes de financement participatif : " Patreon et Tipee : alors oui, mais plusieurs bémols. Déjà, il faut déjà avoir une base solide de public prêt à abandonner la gratuité du net et à donner. Pas gagné surtout sans les réseaux cités plus haut.
              Ensuite, les gens attendent souvent D’AUTRES contreparties que juste le travail déjà fourni. Des avantages, des goodies, etc. Alors que ben, c’est du travail en plus. Cruellement sous sous sous payé. Payer un.e artiste est devenu rendre un service…"
            </span>
            <br />
            <br />De plus, maintenir une communauté active nécessite aussi de l'implication de la part des artistes. Certains organisent des giveaways, des concours de dessin, font des sondages, proposent de répondre à des questions,...
            <br />Être en contact constant avec ses lecteurs et autres internautes est quelque chose de grisant mais Aerinn met en garde sur son aspect chronophage :“ On a tendance à vite se laisser engloutir par les réseaux sociaux, par les commentaires, les messages des gens. Jusqu'à il y a peu je me fixais de répondre à tout le monde, mais c'est une erreur, c'est contre-productif ! Si on passe son temps à communiquer, on n'avance plus nos BDs.
            Un auteur doit savoir être parfaitement organisé et s'en tenir à un planning.”
          </span>
        </div>
        <div class="col-3"></div>
        <div class="col-2 my-5">
          <img src="./assets/img/éditeurs.png" alt />
        </div>
        <div class="col-12"></div>
        <div class="col-3"></div>
        <div class="col-6 text-left">
          <span>
            <h4 class="bleu">c/ Un rapport aux éditeurs qui évolue ?</h4>
            <br />Comme nous l'avons vu précédemment, un auteur amateur ou en voie de professionnalisation est capable de se constituer un public, parfois très large, et cela sans passer par un éditeur.
            <br />Une étude des Labs Hadopi datant de 2012 met en avant ce rapport qui s'est mis en place avec les éditeurs avec l’émergence des blogueurs de bande dessinée :
            <span
              class="sur"
            >“ Il y a constitution d’un public avant l’acte d’achat, contrairement à une démarche commerciale classique, y compris dans les industries culturelles. La revente ou la valorisation de ce public (ou notoriété) à un éditeur permet le passage de la création de l’auteur du web au papier.”</span>
            Ce qui est problématique dans cette observation, c'est que l'auteur n'est à aucun moment rémunéré pour le travail fourni pour réunir son public et que sa notoriété est une condition pour être approché des éditeurs. Ceux-ci n'ont donc pas à prendre le risque de publier une personne qui serait totalement inconnue.
            <br />
            <br />D'un autre côté, même si le travail de communication d'un auteur est difficilement rémunérable, cela lui permet de maîtriser lui-même la promotion de ses créations et sa notoriété. Cela ne doit plus forcément passer par les maisons d'édition, laissant l'auteur libre à ce niveau. La communication avec ses lecteurs peut être bien plus personnelle s'il le désire.
            <br />
            <br />Mais les éditeurs ont parfois tendance à se décharger du travail de communication qui doit accompagner la sortie des bandes dessinées. Certains auteurs portent à bout de bras leur projet jusqu'à sa publication et travaillent en plus sur la constitution d'une audience sur internet pour promouvoir au mieux leur bande dessinée.
            <br />Marie Spénale parle de son expérience avec les éditeurs : "C'était vraiment à moi de tout faire dans les deux cas qui se sont présentés en terme de promo. Il y avait rien du côté des maisons d’édition et au bout d'un moment je suis là : bah au fait je touche infiniment moins de gens en faisant une bd qui est en librairie que quand je publie sur internet."
            Cela peut expliquer en partie le choix de quelques auteurs de s'autoéditer. Pour Souillon, l'auteur de Maliki, qui a été publié pendant plusieurs années chez Ankama, s'autoéditer était aussi un moyen de se détacher du système de l'édition qui ne lui convenait plus.
          </span>
        </div>
        <div class="col-3">
          <div class="bulle18 mx-3 py-3 px-2">
            <span>
              <a
                href="http://labs.hadopi.fr/sites/default/files/ressource/4967/files/auteurtempsnumeriqueld.pdf"
                target="_blank"
              >Méadel Cécile et Sonnac Nathalie, " L’auteur au temps du numérique ", 2012.</a>
            </span>
          </div>
        </div>
        <div class="col-12"></div>
        <div class="col-6 my-5">
          <img src="./assets/img/sastifaction auteurs.jpg" alt />
          <br />
          <span>
            <a
              href="http://www.scam.fr/Portals/0/Contenus/documents/Dossiers/2018/Barometre2018.pdf?ver=2018-03-12-093512-397"
              target="_blank"
            >
              7e baromètre des relations auteur/éditeurs 2018 par la SCAM. Enquête réalisée auprès d’auteurs ( pas uniquement de bande dessinée)
              42% d’auteurs ne sont pas satisfaits de la promotion de leurs livres faite par leurs éditeurs.
            </a>
          </span>
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk18">
        <div class="col-6 my-b">
          <img src="./assets/img/conclusion.gif" alt />
        </div>
        <div class="col-12"></div>
        <div class="col-6 bleu">
          <span>
            <h4>Internet est-il un tremplin pour les jeunes auteurs de bande dessinée dans la vie professionnelle ? (en 2019 en France et en Belgique)</h4>
          </span>
        </div>
        <div class="col-12"></div>
        <div class="col-6 text-left my-4">
          <span>
            Comme nous l'avons vu, internet a évolué au fil des années pour devenir un vaste réseau de communication entre les internautes.
            <br />L’aspect relationnel y est mis en avant notamment à travers les médias sociaux. Les internautes peuvent entrer en contact avec d’autres usagers facilement, au-delà de l'éloignement géographique et sans avoir besoin d'être liés à ces personnes. Pour un artiste, y montrer son travail offre l’opportunité de faire de nouvelles rencontres, et en particulier avec ses semblables. Les auteurs de BD peuvent ainsi prendre connaissance aisément du travail des uns et des autres, contacter des artistes, élargir leur réseau. Comme nous l’avons vu, c’est un moyen d’être reconnu par ses pairs facile d’accès, et c’est déjà un premier pas dans le monde professionnel.
            <br />
            <br />Une des tâches du métier d’auteur est de montrer son travail pour qu’il soit édité ou autoédité et qu’il atteigne les lecteurs. Et pour cela, il n’est pas nécessaire de passer par internet. Il est tout à fait possible de faire lire ses projets à des éditeurs, de se rendre à des festivals, des évènements,... Bien que l'utilisation d’internet par les artistes pour montrer leur travail soit très répandue, ce n’est pas un passage obligé pour se professionnaliser dans la bande dessinée. C’est tout de même à son avantage d’y être référencé, pour les personnes qui souhaiteraient accéder facilement à un minimum d'informations sur le travail d’un artiste apprécié.
            <br />
            <br />Internet peut être pensé comme une simple vitrine d’exposition de son travail mais aussi comme le prolongement de l’activité d’auteur de bande dessinée voir même comme partie intégrante du métier. Internet offre donc de nouvelles manières de se professionnaliser.
            <br />
            <br />Certaines bandes dessinées ont sans doute une plus grande nécessité à se trouver diffusées sur internet, de par leur thématique, leur format, l’importance dans la démarche de dialoguer avec son public. Dans ce cas, internet peut agir comme un véritable tremplin. Être présent en ligne peut offrir des opportunités de travail de fil en aiguille.
            <br />
            <br />Nous l’avons constaté au travers des autrices et auteurs interviewés, tous les quatre sont très actifs en ligne, mais leurs pratiques sont variées. On note tout de même l’importance qu’ils portent au contact qu’ils ont avec leurs lecteurs, qu’ils expriment chacun à leur manière. Avec internet, il est aisé de communiquer avec ses lecteurs ainsi que d’autres internautes. Cela aide certains à sortir de l’isolement, à se motiver, à renforcer leurs liens avec d’autres artistes, à recevoir des conseils et parfois même d’être supporté financièrement directement par sa communauté.
            <br />
            <br />Internet est un espace où le monde entier a accès à une publication d’un artiste, mais ce n’est pas pour autant qu’il sera vu, car sa présence aux yeux des autres dépend de plus en plus de règles algorithmiques opaques. D’où la nécessité d’accorder du temps pour donner de la visibilité à son travail. C’est un labeur de longue haleine qui se construit au fil des mois, des années… Avoir une présence en ligne est chronophage et l’auteur doit trouver le bon équilibre entre le temps de travail et de communication pour ne pas être débordé.
            <br />Cela demande par ailleurs des compétences normalement pas affiliées au métier d’auteur : tout le monde n’a par exemple pas la même aisance à communiquer sur les différentes plateformes. Les médias sociaux encouragent la mise en avant d’un individu, en l'occurrence l’auteur, qui au-delà de ses bandes dessinées, partage son univers, son quotidien avec son public. Le lecteur y est mis avant tout en rapport avec l’auteur, presque plus que son œuvre.
            <br />
            <br />Internet est bénéfique à l'auteur s'il est capable et a l'envie de diversifier ses activités (un auteur peut être aussi streamer, vidéaste, musicien). Mais cela ne doit pas se faire au dépend des tâches non artistiques qui incombent au métier et qui viendraient se superposer à chaque nouvelles pratiques (compta, gestion de communauté, etc.)
            Notons que la présence en ligne n’est pas toujours quelque chose de régulier, un auteur peut être très actif pendant quelques années puis laisser en friche ses sites, et pourquoi pas y revenir plus tard.
            <br />
            <br />Malgré ces constats, il n'y a pas de chemin prédéterminé pour se professionnaliser dans la bande dessinée; il suffit de suivre simplement ce qui nous correspond le plus en prenant en compte les différentes possibilités, et surtout de faire des bandes dessinées.☺
          </span>
          <br />
        </div>
        <div class="col-12"></div>
        <div class="col-9">
          <img src="./assets/img/bd-fin.png" alt />
        </div>
        <div class="col-12">
          <hr />
        </div>
      </div>
      <div class="row d-flex container-fluid justify-content-center p-0 m-0 chunk19">
        <div class="col-6 text-left">
          <span>
            <h4 class="bleu">Bibliographie:</h4>
            <h5 class="bleu">Mémoires, thèses, articles académiques :</h5>
            <ul>
              <li>
                • Chiron Julia, “ Le neuvième art sur Internet : les blogs de bande dessinée », mémoire de fin d’études, 2008.
                <a
                  href="http://neuviemeart.citebd.org/spip.php?page=memoire&id_memoire=16"
                  target="_blank"
                >http://neuviemeart.citebd.org/spip.php?page=memoire&id_memoire=16</a>
              </li>
              <li>
                • Condomines Fiammetta " Paupérisation des auteurs et édition numérique ", mémoire de fin d’études, 2017.
                <a
                  href="http://neuviemeart.citebd.org/IMG/pdf/memoire_fiammetta_condomines_2017.pdf"
                  target="_blank"
                >http://neuviemeart.citebd.org/IMG/pdf/memoire_fiammetta_condomines_2017.pdf</a>
              </li>
              <li>
                • Falgas Julien, " État des lieux numérique ", 2014.
                <a
                  href="https://hal.archives-ouvertes.fr/hal-01310852/document"
                  target="_blank"
                >https://hal.archives-ouvertes.fr/hal-01310852/document</a>
              </li>
              <li>
                • Falgas Julien, " Raconter à l’ère numérique auteurs et lecteurs héritiers de la bande dessinée face aux nouveaux dispositifs de publication ", thèse de doctorat, 2014
                <a
                  href="http://docnum.univ-lorraine.fr/public/DDOC_T_2014_0112_FALGAS.pdf"
                  target="_blank"
                >http://docnum.univ-lorraine.fr/public/DDOC_T_2014_0112_FALGAS.pdf</a>
              </li>
              <li>
                • Méadel Cécile et Sonnac Nathalie, " L’auteur au temps du numérique ", 2012.
                <a
                  href="http://labs.hadopi.fr/sites/default/files/ressource/4967/files/auteurtempsnumeriqueld.pdf"
                  target="_blank"
                >http://labs.hadopi.fr/sites/default/files/ressource/4967/files/auteurtempsnumeriqueld.pdf</a>
              </li>
              <li>
                • Granovetter Mark, " Strength of Weak Ties ", American Journal of Sociology, 1973.
                <a
                  href="https://www.cs.umd.edu/~golbeck/INST633o/granovetterTies.pdf"
                  target="_blank"
                >https://www.cs.umd.edu/~golbeck/INST633o/granovetterTies.pdf</a>
              </li>
            </ul>
            <h5 class="bleu">Articles :</h5>
            <ul>
              <li>
                • Baudry Julien, « Histoire de la bande dessinée numérique française, partie 3 : les blogs bd, une spécificité française ? », 2012.
                <a
                  href="http://neuviemeart.citebd.org/spip.php?article395"
                  target="_blank"
                >http://neuviemeart.citebd.org/spip.php?article395</a>
              </li>
              <li>
                • Lisef, “Les réseaux sociaux signent-ils la fin des auteurs de BD sur internet ?”, 2018.
                <a
                  href="http://www.9emeart.fr/post/evenement/general/les-reseaux-sociaux-signent-ils-la-fin-des-auteurs-de-bd-sur-internet-8519"
                  target="_blank"
                >http://www.9emeart.fr/post/evenement/general/les-reseaux-sociaux-signent-ils-la-fin-des-auteurs-de-bd-sur-internet-8519</a>
              </li>
              <li>
                • Lisef, “Interview : Maliki nous parle Tipeee, milieu de l’édition et avenir de la BD”, 2018.
                <a
                  href=" http://www.9emeart.fr/post/interview/franco-belge/interview-maliki-nous-parle-tipeee-milieu-de-l-edition-et-avenir-de-la-bd-8361"
                  target="_blank"
                >http://www.9emeart.fr/post/interview/franco-belge/interview-maliki-nous-parle-tipeee-milieu-de-l-edition-et-avenir-de-la-bd-8361</a>
              </li>
              <li>
                • Lisef, “Vivre grâce à Tipeee : la réponse des auteurs de BD à la crise”, 2018.
                <a
                  href="http://www.9emeart.fr/post/evenement/general/vivre-grace-a-tipeee-la-reponse-des-auteurs-de-bd-a-la-crise-8344"
                  target="_blank"
                >http://www.9emeart.fr/post/evenement/general/vivre-grace-a-tipeee-la-reponse-des-auteurs-de-bd-a-la-crise-8344</a>
              </li>
              <li>
                • Malle Mirion, thread Twitter, 2018.
                <a
                  href="https://twitter.com/ohhmarion/status/978643561561362433"
                  target="_blank"
                >https://twitter.com/ohhmarion/status/978643561561362433</a>
              </li>
              <li>
                • Kelsey Ables, “The Rise and Fall of Internet Art Communities”, 2019.
                <a
                  href="https://www.artsy.net/article/artsy-editorial-rise-fall-internet-art-communities?utm_medium=social&utm_source=facebook&utm_campaign=editorial&fbclid=IwAR3hVEDVLxN629-YVa9veAgETKPybB1Mllt4_SihZZvxiSv8ADkRguE5-YA"
                  target="_blank"
                >https://www.artsy.net/article/artsy-editorial-rise-fall-internet-art-communities?utm_medium=social&utm_source=facebook&utm_campaign=editorial&fbclid=IwAR3hVEDVLxN629-YVa9veAgETKPybB1Mllt4_SihZZvxiSv8ADkRguE5-YA</a>
              </li>
              <li>
                • O’Reilly Tim, “Not 2.0?”, 2005
                <a
                  href="http://radar.oreilly.com/2005/08/not-20.html"
                  target="_blank"
                >http://radar.oreilly.com/2005/08/not-20.html</a>
              </li>
              <li>
                • O’Reilly Tim, “ Web 2.0 compact definition? ”, 2005
                <a
                  href="http://radar.oreilly.com/2005/10/web-20-compact-definition.html"
                  target="_blank"
                >http://radar.oreilly.com/2005/10/web-20-compact-definition.html</a>
              </li>
              <li>
                • Beaudouin Valérie, “De la publication à la conversation. Lecture et écriture électronique”, Réseaux, n°116, p199-225, 2002.
                <a
                  href="https://www.cairn.info/revue-reseaux1-2002-6-page-199.htm"
                  target="_blank"
                >https://www.cairn.info/revue-reseaux1-2002-6-page-199.htm</a>
              </li>
              <li>
                • Beaudouin Valérie et Velkovska Julia, “Constitution d’un espace de communication sur Internet (forums, pages personnelles, courrier électronique…)”, Réseaux n°97, p121-177, 1999.
                <a
                  href="https://www.persee.fr/doc/reso_0751-7971_1999_num_17_97_2169#xd_co_f=NjJlNTYzZjYtNTg5NC00M2U5LTg4YWQtODU4NjNlZjE5NTVm~"
                  target="_blank"
                >https://www.persee.fr/doc/reso_0751-7971_1999_num_17_97_2169#xd_co_f=NjJlNTYzZjYtNTg5NC00M2U5LTg4YWQtODU4NjNlZjE5NTVm~</a>
              </li>
              <li>
                • “L’évolution d’internet, le web 2.0”, 2011.
                <a
                  href="https://www.ladocumentationfrancaise.fr/dossiers/internet-monde/web2.0.shtml"
                  target="_blank"
                >https://www.ladocumentationfrancaise.fr/dossiers/internet-monde/web2.0.shtml</a>
              </li>
              <li>
                • Rouse Margaret, “ Que signifie internet ? ”, 2016.
                <a
                  href="https://whatis.techtarget.com/fr/definition/Internet"
                  target="_blank"
                >https://whatis.techtarget.com/fr/definition/Internet</a>
              </li>
              <li>
                • Duvelleroy Camille, “ÉTÉ – Saison 1 – 2017 – Feuilleton BD sur Instagram”
                <a
                  href="http://supersimone.com/project/ete-2017-feuilleton-bd-instagram/"
                  target="_blank"
                >http://supersimone.com/project/ete-2017-feuilleton-bd-instagram/</a>
              </li>
              <li>
                • Moulin Mélodie, “Réseaux sociaux ou médias sociaux : quelles différences ?”, 2016.
                <a
                  href="https://culture-formations.fr/reseaux-medias-sociaux-differences/"
                  target="_blank"
                >https://culture-formations.fr/reseaux-medias-sociaux-differences/</a>
              </li>
            </ul>
            <h5 class="bleu">Sites des auteurs et autrices présentés :</h5>
            <ul>
              <li>
                • Marie Spénale :
                <a
                  href="https://www.youtube.com/channel/UCpg24a2OkRJyhZhfA6jW_kw/featured"
                  target="_blank"
                >https://www.youtube.com/channel/UCpg24a2OkRJyhZhfA6jW_kw/featured</a>
              </li>
              <li>
                • Sourya :
                <a
                  href="https://www.twitch.tv/sulhya"
                  target="_blank"
                >https://www.twitch.tv/sulhya</a>
              </li>
              <br />
              <li>
                • Mirion Malle :
                <a
                  href="http://www.mirionmalle.com/"
                  target="_blank"
                >http://www.mirionmalle.com/</a>
              </li>
              <li>
                • Aerinn :
                <a
                  href="https://fr.tipeee.com/aerinn-art"
                  target="_blank"
                >https://fr.tipeee.com/aerinn-art</a>
                <a
                  href="https://fr.ulule.com/chronoctis-express-tome-2"
                  target="_blank"
                >https://fr.ulule.com/chronoctis-express-tome-2</a>
              </li>
              <li>
                • Louise Joor :
                <a
                  href=" https://louisejoor.blogspot.com/2019/04/laventure-commence.html?m=1"
                  target="_blank"
                >http://louisejoor.blogspot.com/2018/09/vers-une-nouvelle-aventure.html?m=1</a>
              </li>
              <li>
                • Maliki :
                <a
                  href="http://maliki.com/strips/a-croisee-chemins/"
                  target="_blank"
                >http://maliki.com/strips/a-croisee-chemins/</a>
              </li>
              <li>
                • Diane Truc :
                <a
                  href=" https://diane-truc.tumblr.com/post/180791511824/the-purge-selfdestroy-2018-instagram"
                  target="_blank"
                >https://diane-truc.tumblr.com/post/180791511824/the-purge-selfdestroy-2018-instagram</a>
              </li>
              <li>
                • Lewis Trondheim :
                <a
                  href="https://www.lewistrondheim.com/blog/"
                  target="_blank"
                >https://www.lewistrondheim.com/blog/</a>
              </li>
              <br />
              <li>
                • Laurel :
                <a
                  href="https://bloglaurel.com/post/californid-la-page-93/1315"
                  target="_blank"
                >https://bloglaurel.com/post/californid-la-page-93/1315</a>
              </li>
              <li>
                • Lisa Mandel :
                <a
                  href="https://www.instagram.com/p/B0OUUUJh5w_/"
                  target="_blank"
                >https://www.instagram.com/p/B0OUUUJh5w_/</a>
              </li>
              <li>
                • Ronzeau Romain :
                <a
                  href="http://commedesguilis.blogspot.com/2009/05/hommage-la-blogosphere.html"
                  target="_blank"
                >http://commedesguilis.blogspot.com/2009/05/hommage-la-blogosphere.html</a>
              </li>
              <li>
                • Alex Norris :
                <a
                  href="https://www.instagram.com/webcomic_name/?hl=fr"
                  target="_blank"
                >https://www.instagram.com/webcomic_name/?hl=fr</a>
              </li>
            </ul>
            <h5 class="bleu">Enquêtes et statistiques :</h5>
            <ul>
              <li>
                • États Généraux de la Bande Dessinée (EGBD), " Enquête auteurs 2016 Résultats statistiques ", 2016.
                <a
                  href="http://www.ar2l-hdf.fr/upload/medias/egbdenqueteauteurs2016.pdf"
                  target="_blank"
                >http://www.ar2l-hdf.fr/upload/medias/egbdenqueteauteurs2016.pdf</a>
              </li>
              <li>
                • CREDOC, Enquêtes sur les “Conditions de vie et les Aspirations des Français ”, 2018.
                <a
                  href
                  target="_blank"
                ></a>
              </li>
              <li>
                <a
                  href="https://www.credoc.fr/publications/barometre-du-numerique-2018"
                  target="_blank"
                >https://www.credoc.fr/publications/barometre-du-numerique-2018</a>
              </li>
              <li>
                • SCAM (Société civile des auteurs multimedia), " 7ème baromètre des relations auteurs / éditeurs, un monde perfectible", 2018.
                <a
                  href="http://www.scam.fr/Portals/0/Contenus/documents/Dossiers/2018/Barometre2018.pdf?ver=2018-03-12-093512-397"
                  target="_blank"
                >http://www.scam.fr/Portals/0/Contenus/documents/Dossiers/2018/Barometre2018.pdf?ver=2018-03-12-093512-397</a>
              </li>
              <li>
                • Twitch Statistics & Charts :
                <a
                  href="https://twitchtracker.com/statistics"
                  target="_blank"
                >https://twitchtracker.com/statistics</a>
              </li>
            </ul>
            <h5 class="bleu">Vidéos, podcasts :</h5>
            <ul>
              <li>
                • Braun Guillaume, " Streamers ", 2019.
                <a
                  href="https://www.arte.tv/fr/videos/RC-014307/streamers/"
                  target="_blank"
                >https://www.arte.tv/fr/videos/RC-014307/streamers/</a>
              </li>
              <li>
                • Conférence de l’AdaBD au Festival d’Angoulême “Créer et maintenir sa communauté de lecteur(trice)s : expériences croisées”, 2019.
                <a
                  href="http://jetfm.fr/site/Jet-fm-a-Angouleme-du-23-au-27.html"
                  target="_blank"
                >http://jetfm.fr/site/Jet-fm-a-Angouleme-du-23-au-27.html</a>
              </li>
              <li>
                • Sihachakr Sourya (sulhya) " Twitch et moi, une histoire d’amour ", 2018.
                <a
                  href="https://www.twitch.tv/videos/233003804"
                  target="_blank"
                >https://www.twitch.tv/videos/233003804</a>
              </li>
              <li>
                • Conseil économique social et environnemental, " Colloque " lien social et réseaux sociaux " débats de la matinée - cese ", 2014.
                <a
                  href="https://www.youtube.com/watch?v=SbdQiLhpONU"
                  target="_blank"
                >https://www.youtube.com/watch?v=SbdQiLhpONU</a>
              </li>
              <li>
                • Evrard Cyrielle (Yeah Cy), " Auto-édition ; le remède miracle ? ", 2019.
                <a
                  href="https://www.youtube.com/watch?v=hkSpvtSyKmc"
                  target="_blank"
                >https://www.youtube.com/watch?v=hkSpvtSyKmc</a>
              </li>
              <li>
                • Lou Lubie “Comment vivre du métier d’auteur de BD ?”, 2018
                <a
                  href="https://www.youtube.com/watch?v=lAC6vi3v9A0"
                  target="_blank"
                >https://www.youtube.com/watch?v=lAC6vi3v9A0</a>
              </li>
              <li>
                • Iva (Art Side of Life ), " Part 1: How to get noticed as an artist on social media -with Sweeney Boo ", 2018.
                <a
                  href="https://www.youtube.com/watch?v=uNbzI64hudU"
                  target="_blank"
                >https://www.youtube.com/watch?v=uNbzI64hudU</a>
              </li>
              <li>
                • Nicolas R, " Le RDV Otaku #04 COMMENT REUSSIR SA CAMPAGNE ULULE !? ", 2018.
                <a
                  href="https://www.youtube.com/watch?v=fwFA-XOpGrU&index=4&list=LLRNthFnbZVZ2zWZZy9L_qHA&t=5891s"
                  target="_blank"
                >https://www.youtube.com/watch?v=fwFA-XOpGrU&index=4&list=LLRNthFnbZVZ2zWZZy9L_qHA&t=5891s</a>
              </li>
              <li>
                • Bergère Sylvain, “Une contre-histoire de l’Internet”, 2013
                <a
                  href="https://www.youtube.com/watch?v=Bciz1eR9vgk"
                  target="_blank"
                >https://www.youtube.com/watch?v=Bciz1eR9vgk</a>
              </li>
              <li>
                • Canto-Sperber Monique, " Questions d’éthique | 13-14 : les réseaux sociaux ", 2011.
                <a
                  href="https://www.franceculture.fr/emissions/questions-dethique-13-14/les-reseaux-sociaux"
                  target="_blank"
                >https://www.franceculture.fr/emissions/questions-dethique-13-14/les-reseaux-sociaux</a>
              </li>
              <li>
                • Tisseron Serge, " Matières à penser avec Serge Tisseron : Splendeurs et misères des réseaux sociaux ", 2018.
                <a
                  href="https://www.franceculture.fr/emissions/matieres-a-penser-avec-serge-tisseron/splendeurs-et-miseres-des-reseaux-sociaux"
                  target="_blank"
                >https://www.franceculture.fr/emissions/matieres-a-penser-avec-serge-tisseron/splendeurs-et-miseres-des-reseaux-sociaux</a>
              </li>
            </ul>
            <h5 class="bleu">Livres :</h5>
            <ul>
              <li>
                • Beuscart, J. S., Dagiral, E., & Parasie, S. “Sociologie d’Internet”, Armand Colin, 2016.
                <a
                  href=" https://www.armand-colin.com/sociologie-dinternet-9782200612429"
                  target="_blank"
                >https://www.armand-colin.com/sociologie-dinternet-9782200612429</a>
              </li>
              <li>
                • Webcomic friends, “ Making money from webcomics “, 2018.
                <a
                  href="https://issuu.com/sarjakuvakeskus/docs/makingmoneyfromwebcomics2018"
                  target="_blank"
                >https://issuu.com/sarjakuvakeskus/docs/makingmoneyfromwebcomics2018</a>
              </li>
              <li>
                • Lafargue Jean-Noël et Burniat Mathieu, “Internet, au-delà du virtuel”,
                La petite Bédéthèque des Savoirs, Le Lombard, 2017.
              </li>
              <li>
                • Leontsini Mary et Leveratto Jean-Marc “Sociabilité littéraire et communication numérique”, Éditions de la Bibliothèque publique d’information, 2008.
                <a
                  href="http://books.openedition.org/bibpompidou/209?lang=fr"
                  target="_blank"
                >http://books.openedition.org/bibpompidou/209?lang=fr</a>
              </li>
              <li>
                • Beuscart Jean-Samuel et Crepel Maxime “Chapitre 10 : Les plateformes d’autopublication artistique en ligne : quatre figures de l’engagement des amateurs dans le Web 2.0”. (Dans “Les stratèges de la Notoriété” de Lizé Wenceslas, Naudier Delphine et Sofio Séverine, Éditions des archives contemporaines, 2014.
                <a
                  href="https://www.academia.edu/10898307/Les_plateformes_dautopublication_artistique_en_ligne"
                  target="_blank"
                >https://www.academia.edu/10898307/Les_plateformes_dautopublication_artistique_en_ligne</a>
              </li>
            </ul>
            <hr />

            <h4 class="bleu mt-5">Interviews :</h4>

            <h5 class="jaune">Marie Spénale</h5>
            <span class="bleu">Interview réalisée en avril 2019</span>
            <br />
            <b>Quand as-tu commencé a publier sur internet et pourquoi?</b>
            <br />Mon premier blog je l’ai ouvert en troisième, donc j’étais jeune. J’ai pas très envie de calculer depuis combien d’années ça fait mais c’est beaucoup. C’était sur les blogs msn. Franchement c’est un truc qui a même pas marché j’aurais mieux fait de faire un skyblog au moins ce serait resté dans la postérité. C’était msn qui avait une plateforme de blogs à côté, je suis passée très vite à blogspot par contre après.
            <br />
            <br />
            <b>Qu’est ce qui t’avais poussée à publier ton travail si jeune?</b>
            <br />Parce qu’en fait c’était un peu le moment où il y avait le 33 rue carambole dans spirou c’était une rubrique où il y avait Laurel, Cha et Melaka qui faisaient des BD ensemble. C’est pour ça que je me suis dit “Ah bon, il y a de la BD sur internet!”, du coup je suis allée voir ça et j’étais “wahou trop cool!”. Et après il y avait les blogs BD qui se lançaient, il y en avait un peu partout, et je voulais faire pareil. En plus j’étais au collège, j’avais plein de temps.
            <br />
            <br />
            <b>C’était pour montrer à tes amis, ou pour toi?</b>
            <br />Nan, c’était pour la gloire internationale, direct! Je sais pas trop quel était le but à la base… Ouais pour avoir un but quand je dessinais, au moins je mettais tous mes dessins là, je pouvais les retrouver et tout.
            <br />
            <br />
            <b>Et tu publiais plutôt des illustrations à l’époque?</b>
            <br />Oui, des fois des petites BD quand même. Je pense que c’était une majorité d’illustrations. Moi j’ai toujours été quand même très très illustration
            <br />
            <br />
            <b>Tu mettais un peu des anecdotes sur ta vie?</b>
            <br />Oui bien sûr, mais de toute façon c’était trop à la mode, tout le monde faisait ça!
            <br />
            <br />
            <b>Et aujourd’hui tu publies sur plein de plateformes différentes.</b>
            <br />Oui, mais j’ai toujours mon blog techniquement…En fait là ou je publie le plus aujourd’hui c’est Instagram, de très loin. Après je suis un peu sur youtube aussi, ça c’est encore récent, je suis en train de découvrir. Mais donc si on veut voir mon travail c’est Instagram qui est le mieux. En fait j’ai toujours un blog et de manière assez cocasse c’est là ou je vais mettre mes trucs plus personnels. Je vais y mettre des BD plus introspectives, plus raconter ma vie, ce que je fais pas du tout sur les réseaux sociaux. Voilà comme ça je me dis, c’est vraiment les gens qui… les vrais quoi qui vont sur le blog! En fait le truc des réseaux sociaux par rapport à un blog, c’est qu’il y a le partage qui compte beaucoup et que du coup quand tu postes un truc c’est quand même dans le but que ce soit repartagé par d’autres personnes qui vont s’approprier ton propos. Ça peut être très bien mais quand tu fais de la BD un peu plus personnelle je trouve que ça a pas trop de sens finalement de se mettre sur les réseaux sociaux parce que à moins que t’aies envie que les gens se reconnaissent dans ce que tu racontes, si tu es dans un démarche purement personnelle, c’est un peu bizarre en fait.
            <br />
            <br />
            <b>Toi tu vois les réseaux sociaux plus comme un espace de promotion, de création ou un peu des deux?</b>
            <br />C’est ça qui est un peu triste, c’est que c’est vraiment pas mal un espace de promotion. Instagram c’est pas le réseau le plus spontané non plus. Mais après j’essaye de temps en temps, j’ai des petits moment ou je suis plus spontanée et je me dis allez, je poste mes trucs et je m’en fiche si c’est pas fini! Mais je sais pas, je n’arrive pas trop à m’y tenir au final. Il y a un peu de pression, il y a beaucoup de gens…
            <br />
            <br />
            <b>Il y a un côté vraiment professionnel à ton Instagram, toi c’est bon tu as ton réseau maintenant, mais est ce que tu te dis que des éditeurs vont regarder ton compte?</b>
            <br />Alors, à la base quand je publiais sur Instagram, c’était …enfin c’était pas pareil Instagram au début, c’était un peu plus à l’arrache et tout et je me suis fait beaucoup de connaissances parmi les auteurs. Ça m’a fait un petit réseau comme ça et même aujourd’hui, c’est principalement l’intérêt pour moi, c’est de voir le travail d’autres personnes. Et après professionnellement je n’en ai pas besoin pour faire ma promo, pour trouver du travail directement, parce que comme tu dis, j’ai mon réseau. Et en plus, les directeurs artistiques ils vont pas forcément rechercher des gens sur les réseaux sociaux, il vont peut être plus regarder ce qu’il y a dans les autres magasines, ou même limite je me rends compte qu’il regardent plus mon blog et assez peu mon compte Instagram qui est pourtant infiniment plus à jour quoi. C’est assez marrant, il sont un peu en arrière!
            <br />Moi j’ai un peu deux carrières différentes, je fais d’un côté de l’illustration, et de l’autre de la BD. On dirait que c’est le mêmes choses mais ce sont pas du tout les mêmes personnes, c’est pas les mêmes manières de fonctionner. Quand je dis que pour mon travail je n’ai pas besoin des réseaux sociaux c’est parce que mon travail c’est surtout de l’illustration parce que c’est ça qui me rapporte des sous. Et dans ce milieu là, je n’ai pas l’impression qu’on vienne beaucoup chercher sur les réseaux sociaux. C’est assez classique, assez vieux jeu. Il y a quelques directeurs artistiques qui trainent sur les réseaux sociaux, mais c’est plus anecdotique, et c’est plus des gens qui me connaissent déjà en général. Et par contre en bande dessinée, j’ai l’impression que c’est beaucoup plus important, je vois que les gens sont plus sensibles si tu as des abonnés ou pas, parce que tu vas plus publier en tant qu’auteur. Alors que moi en illustration, je suis limite prestataire, on vient me voir pour que j’illustre des trucs, c’est vraiment pour mon savoir faire alors qu’en BD, ça m’énerve un peu, mais on va faire attention si j’ai beaucoup de followers…C’est quand même un argument malgré tout.
            <br />
            <br />
            <b>Comment tu en as déduit ça?</b>
            <br />J’en ai déduis ça peut être parce que je suis un peu parano! Tu sens que les éditeurs ils insistent pour que tu fasse ta promo sur les réseaux sociaux et…bah c’est pas mon job en fait! C’est pas mon job de vendre mon livre, c’est pour ça que vous êtes là éditeurs! Je sens qu’il y a un peu ce conflit.
            Les réseaux sociaux c’est un plateforme de promotion de mon travail mais dans l’idéal j’aimerais que ça le soit de moins en moins et que les éditeurs et les gens qui travaillent avec moi les prennent moins pour des panneaux publicitaires.
            <br />
            <br />
            <b>Et si tu n’avais pas cette pression qu’aimerais tu poster sur les réseaux? Des croquis ou autres?</b>
            <br />En fait il y a de plus en plus de gens qui me suivent, donc il y a beaucoup de gens qui regardent et je ne vais plus mettre de trucs trop débiles, des choses faites à l’arrache, mais c’est un peu moi toute seule qui me restreint. Je pourrais en vrai! Je suis toujours en questionnement sur les réseaux sociaux, pour l’instant je fais quelque chose de safe.
            <br />C’est compliqué, je suis un peu entre deux eaux. Instagram c’est un peu un jeu, et grossir sur Instagram, c’est un peu rigolo. Est-ce que je vais pas jouer le jeu à fond sur Instagram, en mettant du contenu hyper Instagram compatible, ça peut être marrant.
            <br />
            <br />
            <b>On retrouve ce conflit entre ce qui relève de la vie privée et de ce que tu peux partager, est ce que tu fais attention à ce que tu partages?</b>
            <br />Mon compte Instagram est plus pro, des fois (c’est pour ça que c’est toujours un peu de la promotion) je vais mettre des BD un peu plus anciennes en story de manière un peu plus informelle. Mais ces BD sont hyper contrôlées, je parle pas de ma vie, je montre ce que je fais en tant qu’illustratrice, jamais je vais parler de trucs trop personnels. A la limite, c’est sur mon blog. Sinon j’ai un démarche de carnets pour moi en plus, qui fini très rarement sur les réseaux sociaux, raconter ma vie ça reste quelque chose vraiment pour moi même. Sur Instagram, j’ai quand même un autre compte juste pour ma vie privée
            <br />Mais j’ai l’impression que pour que ça marche sur Instagram, faut ptète donner un peu plus de soi aussi.
            A côté d’Instagram, j’ai depuis quelques temps Youtube, et ça c’est encore quelque chose de différent. J’ai envie de faire des vlogs, c’est un contenu que j’aime bien regarder, je me dis que ça peut-être rigolo à faire. Mais dans ce genre de cas c’est hyper compliqué, elle commence et elle s’arrête où la vie d’illustratrice et ma vie perso…C’est hyper mélangé.
            <br />
            <br />
            <b>Qu’est ce qui t’a donné envie de te lancer sur youtube?</b>
            <br />Alors parce que je passais ma vie dessus à regarder des vidéos, il y a du contenu que j’aime bien regarder, j’avais envie de tenter ça, de parler un peu plus de mon métier. Malgré tout de retrouver un lien plus complexe que ce qu’on a sur Instagram qui est hyper “Tenez, un image!” Youtube ça permet d’avoir un échange, comme j’avais sur mon blog avant. Le ratio vues likes et commentaires est énorme par rapport à Instagram, les gens sont hyper investis sur youtube.
            <br />Twitter c’est encore autre chose, moi je tweete vraiment jamais, une fois de temps en temps ou pour parler du métier d’auteur, parce que je suis à la Chartre, un syndicat des illustrateurs et auteurs jeunesse et les gens sont assez actifs sur ces questions. En plus c’est des questions qui m’intéressent aussi. Et ça m’intéresse d’en parler sur ce média, parce que c’est un peu fait pour ça Twitter, râler! De temps en temps je mets un dessin, ça marche, mais je sais pas, j’ai un peu de mal… J’aime bien Twitter, je passe mes journées à lire dessus mais je participe assez peu. On revoit un peu toujours les mêmes gens, on s’envoie des messages. Ça marche assez bien de partager ses dessins dessus, mais je pense pas à le faire. Puis ça fait beaucoup de réseaux à force!
            <br />
            <br />
            <b>Comment tu gère ton temps de travail entre la création et la communication?</b>
            <br />C’est un peu compliqué, surtout que aujourd’hui il y a beaucoup de gens dans l’illustration et la BD dont les réseaux sociaux font réellement partie de l’activité. Et moi pas du tout, c’est vraiment un bonus, ça m’apporte pas de clients, enfin en BD ça m’aide peut être à négocier des trucs. Ça m’apporte pas d’argent concrètement, c’est vraiment pour m’amuser, un peu pour faire ma promo Instagram. Plus un portfolio en ligne qui est facilement accessible, mais c’est même pas vraiment le but car si je veux démarcher j’ai un autre portfolio qui est beaucoup plus pro. Je galère un peu à tout faire, parce que j’ai quand même un métier à temps plein. Faire des vidéos youtube ça prend un temps de ouf! Après mon temps libre…quand j’ai du temps libre je dessine pour moi donc ça change finalement pas beaucoup!
            <br />Un espace qui est un peu cool, c’est les stories Instagram, je peux y mettre un peu plus les coulisses de ce que je fais je peux plus interagir pour de vrai donc c’est un peu plus cool. Mais même là je suis pas hyper active par rapport à d’autres personnes.
            <br />
            <br />
            <b>Est-ce que c’est important pour toi d’avoir un contact avec tes lecteurs? Tu vas sur des festivals, tu fais attention à proposer du contenu régulièrement sur internet?</b>
            <br />Alors… j’ai sorti 2 BD, dont une pour les enfants donc ça limite malgré tout mon activité de dessinatrice de BD et en plus je fais assez peu de festivals. Depuis que j’ai youtube ça marche beaucoup mieux, en fait en dédicace je vois que des gens qui me connaissent via les réseaux. A Angoulême dernier, c’est un peu bizarre, tous les gens que j’ai vu en dédicace pour mon livre jeunesse, c’était des adultes qui me suivaient sur Youtube. Je le prends forcément en compte, si je fais de la BD jeunesse bah finalement je touche pas les bonnes personnes. Ça me fait me questionner. Est-ce que je continue à faire de la jeunesse par exemple?
            <br />J’avais l’idée de faire un chaine youtube depuis longtemps, mais vraiment mes premières vidéos c’était en accompagnement pour ma BD jeunesse parce que je savais que les gens sur youtube sont jeunes. Du coup si je leur parle de BD et tout, je vais pouvoir parler de ma bd et la vendre comme ça! Et en fait, il y a des gens hyper jeunes sur YouTube mais moi les gens qui me regardent ils sont plutôt adultes!
            <br />
            <br />
            <b>J’ai vu que sur ta chaine tu avais fait une petite vidéo promotionnelle de ta BD, mais c’est toi qui l’a faite? C’est pas l’éditeur qui t’a payé?</b>
            <br />OOh non, c’est moi qui l’ai faite toute seule dans mon coin, sans tenir au courant mon éditeur même.
            <br />
            <br />
            <b>Il s’étaient un peu chargés de la com quand même?</b>
            <br />C’ était vraiment à moi de tout faire dans les 2 cas qui se sont présentés en terme de promo. il y avait rien du coté des maisons d’édition et au bout d’un moment je suis là : bah au fait je touche infiniment moins de gens en faisant une bd qui est en libraire que quand je publie sur internet. Tu vois quand je publie une vidéo sur internet mon max c’est 250 000 vues, mes bd elles, se sont vendues à 1000 exemplaires. Je vais pas faire de la bd pour les 3 glandus qui passent leur vie en librairie! Surtout dans le cas de la bd jeunesse, on touche tellement peu de gens, d’enfants… Du coup je suis un peu en questionnement. Cette année je suis sur un projet de bande dessinée numérique, été arte ( maintenant été_BD). Ça je suis contente, finalement je crois que ça a plus de sens de faire de bd sur Instagram aujourd’hui que faire de la bd en bouquins. La promotion, c’est pas notre boulot, et l’éditeur se décharge complètement. Et je pense que ça va être à double tranchant pour les éditeurs aussi bientôt.
            <br />
            <br />
            <b>Est ce que tu as pensé a faire un cowfunding pour un de tes projets?</b>
            <br />On me pose souvent la question, moi je suis pas hyper à l’aise, demander de l’argent aux gens ça me plait pas trop. En plus j’aurais vraiment l’impression de perdre un part de liberté si je suis redevable de personnes. Moi le choix que j’ai fait c’est l’illustration de commande, ça c’est mon gagne pain, c’est limite un job à coté et après quand je dessine pour moi quand je fais de la bd, je veux un marge de manœuvre, ma liberté, et je veux pas me sentir redevable, je me sens très vite redevable! Et si il y a des des gens qui commencent à me donner de l’argent il va falloir que je fasse quelque chose qui leur plaise… Je sais que mes parents me donneraient de l’argent, ça me gène… Après pourquoi pas pour un projet qui est ponctuel, un petit projet d’édition que je fais toute seule, ça je commence à y réfléchir.
            <br />Ça pose encore plein de questions. On faisait du fanzine avant qu’il y ai du crowfunding est ce qu’on est obligé de passer par des grosses structures qui prennent des commission, qui vont aussi normer le truc… Est ce qu’il vaut mieux pas essayer d’avancer soit même l’argent?
            <br />
            <br />
            <b>Est-ce que tu estimes que tu as une communauté?</b>
            <br />Je publie sur Instagram depuis une éternité maintenant (2012 environ) pendant très longtemps les gens qui me suivaient, c’était des dessinateurs et moi je suivais des dessinateurs, j’avais un truc un peu fermé.
            <br />Et là avec YouTube ça a carrément changé les gens qui me suivaient ! Avant j’aurais vraiment pas parlé de communauté dans le sens où c’était des gens qui faisaient la même chose que moi qui me suivaient… et là j’ai vachement de gens qui dessinent pas qui me suivent, ça c’est un peu nouveau.
            <br />
            <br />
            <b>En fonction des plateformes ça doit t’apporter un public complétement différent?</b>
            <br />Oui, et ça se transvase. les gens qui me trouvent sur youtube ils viennent me suivre sur Instagram… Et du coup j’ai des gens qui sont un peu “fan”. C’est un peu nouveau comme expérience, c’est assez bizarre honnêtement. Parce qu’avant on me suivait vraiment pour mes dessins. Sur youtube je montre ma tête, je parle aux gens c’est infiniment plus personnifié que avant c’était mon contenu, qui est hyper froid. Et maintenant les gens m’aiment bien?? Il y a un truc vachement plus de personne a personne.
            <br />
            <br />
            <b>Du coup, tu as l’impression que les gens te suivent autant pour ta personnalité que ton travail?</b>
            <br />Clairement sur youtube, c’est la personnalité. je crois que les gens s’en moquent un peu de mes dessins sur youtube! Il ya assez peu de commentaires sur ça au final.
            <br />
            <br />
            <b>T’as des commentaires sur quoi au final?</b>
            <br />Des questions sur ma vie, mais plus professionnelle: “T’as fais quelles études?” par exemple. Ma chaine est très dessin. Les questions portent pas sur mes dessins mais sur la pratique du dessin, et le métier. J’ai des commentaires qui sont gentils. Des trucs qui me paraissent bizarres car ils sont assez déconnectés de ma personne. C’est genre des gens qui me voient sur youtube, il ont une vision faussée, enfin non plutôt partielle de mon métier! On me dit " t’es trop inspirante" alors que t’es en pyjama à 15h!
            <br />Moi je reste assez centrée sur le travail mais il il y a des illustratrices dont l’activité est centrée sur les réseaux sociaux et qui partagent toute leur vie. Et quand elles dessinent, elles dessinent pour les réseaux sociaux, c’est vachement plus tourné vers les gens. C’est vraiment une pratique très différente de la mienne ou moi je fais mes trucs et après je donne un aperçu de ce que je fais sur les réseaux sociaux.
            <br />Le temps que je passe à faire du contenu sur youtube, est ce que c’est pas du temps que je pourrais passer à faire de la BD?
            <br />
            <br />
            <b>Quand tu as ouvert ta chaine youtube tu as pensé au fait que tu pouvais te rémunérer avec?</b>
            <br />Non ça a vraiment pas été le but. Ça paie pas de ouf. Mais honnêtement c’est plutôt une bonne surprise. Il s’est passé quelque chose de très bien, c’est que ma première vidéo est vraiment un carton et du coup chaque mois elle me rapporte de l’argent encore. Donc en gros je gagne environ 100 dollars par mois sur YouTube. C 'était pas prévu. Pour l’instant je garde cet argent et je le réinvestit dans youtube, je m’achète du matériel photo.
            <br />
            <br />
            <b>Les auteurs qui t’entourent, est-ce que tu as l’impression qu’il ont un peu ce même profil? Est ce qu’ils utilisent internet pour montrer leur travail?</b>
            <br />Je pense que tout le monde est sur internet. Il faut forcement avoir un présence en ligne. Ne serait-ce que pour être reconnu parmi ses pairs, pour voir ce qui se fait, que les autres voient ce que tu fais. Quand tu dessines tu montres ton travail, sinon ça veut dire que tu veux pas être pro. Pour montrer aujourd’hui, c’est Internet qui est de très loin le plus pratique. Après tout le monde ne joue pas le jeu à fond. Il y a des gens que j’ai connu sur internet (Karensac, Cy…) Quasiment presque tous mes amis dessinateurs, je les ais connus sur internet, avant de les connaitre en vrai. A part les gens qui étaient en études avec moi. Mais en même temps quand tu es dessinateur, tu es quand même seul chez toi donc pour rencontrer d’autres dessinateurs, c’est pas évident.
            <br />
            <br />
            <b>Tu essaies de toucher un public international?</b>
            <br />Quand je me suis mise sur YouTube je me suis dis : je parle en français, les gens qui me suivent ils vont être francophones. Pour l’instant comme j’ai du travail dans ce que je fais, ça m’intéresse pas d’aller chercher plus de public. Par contre si j’ai envie de changer un peu de voie, par exemple de faire un peu plus de trucs pour les adultes, ça pourrait potentiellement être une voie.
            <br />Professionnellement je dirais que c’est pas si important que ça les réseaux sociaux, en tout cas pour avoir des jobs. Pour se faire connaitre en tant qu’auteur peut être plus. Pour avoir du travail en tant qu’illustrateur ça n’a pas d’importance.
            <br />Aujourd’hui je pense que le meilleur réseau social pour trouver du travail c’est Facebook. Parce que les directeurs artistiques sont dessus.
            Ma page Facebook n’est pas du tout personnelle.
            <br />
            <br />
            <br />
            <br />

            <h5 class="jaune">SOURYA</h5>
            <br />

            <span class="bleu">Interview réalisée en avril 2019</span>
            <br />
            <b>Quand as-tu commencé à publier sérieusement ton travail sur internet et pourquoi? Sur quelle(s) plateforme(s) as-tu commencé? (blog, Facebook,tumblr,…)</b>
            <br />C’était après le BAC, avant j’avais accès à internet mais je m’étais jamais dit que je posterais sur des plateformes. J’étais sur un forum de dessin, ça date, ça s’appelait les Oekaki Board, Et en gros c’était un forum de dessin où les gens postaient des illustrations que les gens pouvaient regarder et commenter. Ça m’inspirait beaucoup, c’était la première plateforme que je voyais qui mettait en scène les dessinateurs. Et ce qui était génial avec ce site, c’est qu’on pouvait enregistrer le processus de dessin en accéléré. C’était super instructif. Toi quand t’es un petit ado, t’avais jamais touché à une tablette graphique avant! D’ailleurs mes premiers dessins je les faisais à la souris. Donc ça c’était ma première expérience sur internet.
            <br />
            <br />
            <b>Tu ne postais pas de bande dessinée à ce moment là ?</b>
            <br />Non pas du tout
            <br />
            <br />
            <b>Tu as ouvert plus tard un blog ? Enfin quelque chose de personnel ?</b>
            <br />Alors j’ai intégré ensuite une école de dessin quand je suis arrivé en prépa. J’ai décidé d’ouvrir un blog parce que je trouvais ça vachement motivant de publier. Et c’était beaucoup plus intensif qu’aujourd’hui à l’époque, c’était presque une obligation pour moi de poster tous les jours. Parce que j’étais là « c’est mon entraînement de dessin, si je poste pas une fois par jour c’est que j’ai raté " . C’était du dessin d’obs, du dessin d’imagination. C’était moi qui m’étais fixé cet objectif, et ça me motivait en fait. Je me disais qu’en faisant ça j’allais progresser. Et d’ailleurs ça m’a vraiment aidé d’entretenir mon blog en parallèle de ma participation sur un forum de dessin, qui était en fait le forum d’un site de cinéma d’animation qui s’appelle Catsuka, ça existe toujours. Et à l’époque il y avait vraiment une très grosse communauté de dessinateurs qui étaient sur le forum. On y postait nos dessins pour y recevoir des critiques.
            <br />
            <br />
            <b>Donc tu as commencé à rentrer dans le milieu avec tout ça ?</b>
            <br />Oui, il y avait un gros engouement sur Catsuka pour se motiver et progresser avoir des conseils etc.
            <br />
            <br />
            <b>Ton blog était plus lié a ta pratique de l’animation ou du dessin de manière plus générale ?</b>
            <br />Plus ma pratique du dessin.
            <br />
            <br />
            <b>Sur ton blog, tu avais un système de commentaires, une interaction avec les gens ou tu réservais plutôt ça pour le forum ?</b>
            <br />C’était activé sur le blog, c’était sur blogspot donc quand tu postais un dessins tu pouvais avoir un retour.
            <br />
            <br />
            <b>Ce qui t’as amené à publier sur internet , ce ne sont donc pas les blogs BD ?</b>
            <br />Non pas du tout, ça commençait à bien se développer mais j’en lisais pas personnellement. Moi c’était plus pour apprendre à dessiner et progresser.
            Après j’ai continué à utiliser mon blog pendant que j’étais à l’école pour me motiver mais c’était moins intensif au fur et à mesure. Je pense que le fait d’avoir un retour, positif ou négatif, c’était motivant. Parce qu’au final ça a payé, ça a permis d’avoir des contacts. Par exemple sur le forum, c’est un peu étrange à dire mais c’est un endroit où je me suis fait beaucoup d’amis, qui sont devenus proches aujourd’hui. Je ne les avais jamais rencontrés avant. À partir du moment où je suis devenu pro, que j’ai fini mes études j’ai commencé à les rencontrer un par un. C’est marrant parce que tout le monde se retrouve au bout d’un moment. On se rappelle toujours de cette période Catsuka où tout le monde postait.
            <br />Ça c’est une autre histoire mais après avoir fini mes études j’ai reçu mon premier taf en BD grâce à mon blog. L’éditeur qui m’avait contacté avait connu mon travail par mon blog, je sais pas comment exactement, mais ils avaient trouvé mes dessins sur internet. Internet c’est pratique pour les artistes, que ce soit en dessin ou en musique, tu peux te faire remarquer. J’ai commencé à faire de la BD en étant publié un peu après 25 ans.
            <br />
            <br />
            <b>Sur quelles plateformes es-tu présent aujourd’hui?</b>
            <br />Je suis partout : sur Instagram, Twitter, Facebook, discord et Twitch maintenant.
            <br />
            <br />
            <b>Tu as quand même tes plateformes préférées? En ce moment je vois que tu utilises très régulièrement Twitch.</b>
            <br />Oui c’est différent parce que les personnes qui me suivent sur Twitch sont pas forcément les mêmes que sur Twitter. Twitch c’est plus pour avoir de la compagnie pendant que je travaille. Je pense que sur les autres plateformes j’essaye d’être plus sérieux. Pour moi c’est pas la même mentalité.
            <br />
            <br />
            <b>Donc selon les plateformes c’est pas le même public ?</b>
            <br />Oui bien sûr, après il y a quelques personnes qui me suivent sur toutes les plateformes, c’est plutôt les dessineux je pense. Sur Twitch les gens qui me suivent dessinent quasiment tous.
            <br />
            <br />
            <b>Quand tu dis que c’est plus pro sur intagram, tu veux dire que c’est presque comme un portfolio ?</b>
            <br />C’est un peu stressant. C’est marrant parce que j’avais pas du tout cette pression là quand j’étais plus jeune, je postais n’importe quoi et je m’en foutais un peu. Mais maintenant j’y réfléchis vraiment à deux fois avant de poster, je suis là « Ah nan c’est pas assez bien !». J’essaye de m’en détacher des fois quand je poste des choses. Mais justement si je compare ça à Twitch, streamer un contenu un peu merdique ça me gène pas du tout, alors que sur tous les autres où je vais poster un dessin, je sais que ça va rester et ça me stresse un peu, j’essaye de poster des choses plus propres. En fait je sais qu’il y a des personnes pro qui vont passer dessus…
            <br />
            <br />
            <b>Ton Twitter et ton Instagram, tu le vois finalement plus comme des espaces de promotion ?</b>
            <br />Oui exactement pour ça. Pour tenir au courant mes lecteurs et pour donner un bonne image pour des éditeurs ou artistes qui passeraient.
            <br />
            <br />
            <b>Tu as des éditeurs qui te suivent sur Instagram ?</b>
            <br />Oui sur Twitter aussi, ils sont partout, ils te contactent beaucoup sur les réseaux sociaux, je reçois des fois des mails, mais aussi des messages sur Instagram et Twitter. J’y reçois beaucoup de demandes de taf.
            <br />
            <br />
            <b>T’as déjà accepté des demandes de cette manière là ?</b>
            <br />Carrément oui, pour des tafs d’illustration, j’ai eu des contact via Instagram d’une éditrice qui m’a contacté et on s’est rencontrés.
            Dans ton parcours tu as eu finalement assez peu eu à faire la démarche d’aller voir directement des éditeurs avec ton portfolio?
            Non je l’ai jamais fait mais après moi j’ai travaillé avec qu’un seul éditeur, j’ai eu beaucoup de chance à ce niveau là, je suis resté avec Ankama dès le début, je fais pas non plus beaucoup de travaux en dehors de ma BD principale. Les seuls tafs que j’accepte ça dépend des plannings qu’ils ont. Si ça tombe sur des plannings où je peux pas travailler dessus, c’est un non direct.
            <br />
            <br />
            <b>Tu accordes beaucoup d’ importance à ce contact avec tes lecteurs ?</b>
            <br />Oui c ‘est vraiment important pour moi. Instagram et Twitter c’est vachement plus pro et même si il y a souvent les mêmes personnes qui likent je n’ai pas l’impression ou le sentiment qu’ils sont aussi proches que mes viewers sur Twitch. Sur Twitch des fois les gens qui viennent me voir ils restent des heures, je trouve ça vraiment étonnant parce qu’il se passe rien sur mon stream. Du coup j’ai l’impression de les connaître un peu. Des fois ils viennent à chaque fois que je streame ou me dire dire « Salut, je reste juste 30 minutes » mais ça fait plaisir quoi !
            <br />
            <br />
            <b>En fait c’est un rendez vous régulier que tu as avec ces gens là?</b>
            <br />Oui, j’ai un rendez vous régulier en ce moment, mais c’est pas aussi régulier sur toute l’année. Ça dépend de l’étape de production dans laquelle je suis : à l’étape d’écriture je streame pas du tout pendant des semaines, des mois même. Et pareil pour le story board c’est un truc que je peux pas du tout streamer par ce qu’il y a rien à partager et que j’ai besoin d’être seul je pense. Pour des esquisses, l’encrage je suis là. Mais il y a des phases ou je suis absent dans l’année.
            <br />
            <br />
            <b>C’est donc à ce moment là où les gens en profitent pour voir tes avancées?</b>
            <br />Ouais c’est vraiment rigolo quoi, puis je sais pas si t’as vu d’autres streameurs, parce que c’est super t’as une vraie communauté qui se crée entre les auteurs déjà premièrement, mais aussi avec les viewers. C’est à dire que la plupart des viewers que tu vas trouver dans un stream - de bd, parce que c’est vraiment un truc de niche – il y a des fortes chances que tu les trouves dans un autre stream d’auteur de bd. Du coup il a ce côté où on partage, on avance tous ensemble avec une communauté de gens qui aiment la BD.
            <br />
            <br />
            <b>Je voyais en effet sur ton stream qui il y avait quelques personnalités de la BD!</b>
            <br />C’est marrant parce quand Cy s’est mise à streamer j’ai l’impression qu’elle a ramené toute une clique d’auteurs et d’autrices qui sont là maintenant et c’est génial. Ça fait grandir le cercle.
            <br />
            <br />
            <b>Et toi ça fait combien de temps que tu es sur Twitch ?</b>
            <br />2016, donc 3 ans. Mais avant j’ai un peu tout testé, j’étais sur youtube. J’avais commencé sur youtube. Je trouvais que c’était super ennuyeux, j’ai très vite basculé sur Twitch.
            <br />
            <br />
            <b>Qu’est ce que ça a apporté en plus Twitch ?</b>
            <br />Les catégories sont mieux faites je sais pas si tu vois ce que c’est que le “host” et le “raid” ? Quand tu finis un stream, tu peux emmener les viewers que t’as directement sur un autre stream. Ton profil sur la plateforme retransmets l’artiste que tu as hosté .
            <br />Ce côté je le retrouvais assez peu sur youtube, où je me retrouvais finalement assez isolé. J’étais pas du tout emballé par la plateforme. Et sur Twitch, je suis tombé amoureux du truc, dès mes premiers stream je me suis fait hosté, je me suis fait raid. Donc pour l’instant je continue, je sais pas où ça va me mener mais c’est agréable en tout cas.
            <br />Ça parle un peu de tout et de rien de ce que j’ai entendu sur le stream, jeux vidéo, nourriture…
            <br />Ça dépend des stream je pense. Des fois il y a des gens qui sont ultra bavards dans le chat et ça peut rendre la discussion marrante. Et c’est vrai que ça me permet de discuter un peu. Il y a des auteurs qui sont en atelier, ils ont pas besoin de ça je pense mais quand t’es tout seul pendant des heures voire des jours…
            <br />
            <br />
            <b>Toi tu travailles seul chez toi en fait ?</b>
            <br />Idéalement c’est bien d’être en atelier parce que ça te fait sortir en plus, ce que le stream ne t’apporte pas. Mais pour l’instant c’est une solution qui est sympathique. Tu rencontres aussi des auteurs. Je l’ai pas mentionné mais grâce ou à cause de Twitch j’ai créé un discord, pour rassembler les gens qui viennent souvent sur mon stream. On fait même des meet up des fois avec les viewers. Il y a une période où j’étais beaucoup plus investi sur ma chaine et je faisais des meet up quasiment tous les mois sur Paris.
            <br />
            <br />
            <b>Du coup c’est majoritairement un public français ?</b>
            <br />En stream oui, j’ai quelques anglophones qui sont là des fois mais très vite les français prennent le dessus. Au départ j’essayais de streamer en anglais parce que je me suis dis que le stream marcherai mieux comme il y a beaucoup d’anglophones sur la plateforme. Mais ça commençait à faire trop de groupes. Du coup je me suis investi sur le français en me disant que c’était plus naturel.
            <br />
            <br />
            <b>À quel point ça influence ton travail de communiquer sur Twitch? Est ce que les gens te donnent des conseils?</b>
            <br />Ça arrive qu’ils voient des erreurs, ça peut aider oui. C’est rare mais c’est vrai qu’une fois j’avais demandé si ils pouvaient me trouver une image de rèf, c’est un peu abusé haha! C’était pour trouver une image de refuge dans une forêt et du coup il y en avait plein qui m’envoyaient des photos, c’était cool. Ça influence peut être pas vraiment sur les dessins ou l’histoire mais ça influence sur mon humeur, sur mon envie de travailler. Ça me permet d’être focus.
            <br />
            <br />
            <b>As-tu pensé à streamer du jeu vidéo, du contenu autre que de la bande dessinée ?</b>
            <br />Si, j’aimerais bien mais il faut le temps et je sais pas quoi streamer en fait. Et puis faut avoir un caractère d’entertainer je pense? À moins que j’aie des réactions hyper accentuées, que je sois en train de rager…Parce que c’est juste pour me voir en train de jouer correctement je vois pas trop ce qu’ils vont en tirer en fait. J’aimerais bien jouer à des jeux vidéo style jrpg pour partager un peu ce que j’aime mais là est-ce que les gens seraient intéressés, je sais pas. J’ai une communauté de personnes qui sont habituées à me voir dessiner plutôt. Mais ça me donne envie, à voir si un jour j’ai le temps faire ça. Peut être de jouer avec des viewers…
            <br />Il y a un truc super cool qui s’appelle drawpile où tu peux dessiner avec tout le monde. J’en faisais avec mes viewers à une époque, c’est super marrant, je trouve ça touchant. Puis c’est une manière pour moi de les remercier. Chaque bouclage de BD je faisais un stream de célébration et on se faisait des drawpiles, j’amenais des invités… Ça marquait bien la fin d’une prod.
            <br />J’avais une émission aussi que j’ai pas du tout entretenue qui s’appelle “Drawing with my crush” C’est quelque chose que j’adorais faire mais le problème c’est que si la personne en face n’est pas équipée d’un matériel de streaming ça passe pas du tout.
            <br />
            <br />
            <b>Pour en revenir au discord, comment ça s’organise ?</b>
            <br />Il y a une période où je streamais pas donc c’était un peu mort mais pour ceux qui sont restés c’est assez organisé en fait. Il y a une dictature pour ceux qui ne respectent pas les règles. J’ai organisé ça comme une sorte de royaume, je suis le seigneur du discord ! Il y a entre autres un dossier entrainement pour les salons de dessin où on poste nos productions, puis il y a la taverne où c’est vraiment n’importe quoi! C’est plus un espace de partage.
            <br />
            <br />
            <b>Tu aurais une définition de ce qu’est une communauté ?</b>
            <br />Ma communauté est plus tournée vers le streaming vu que c’est là bas que je me sens le plus proche de gens. Sur le long terme j’aimerais plus que ma communauté se construise sur la lecture de mes BD. Je ne sais pas si la communauté proche que je me suis faite sur le streaming à lu ma BD. Si je prends par exemple Twitter ou Instagram, la plupart des gens qui me suivent n’ont jamais lu ma BD. Ils aiment juste mes dessins et ils me suivent pour ça.
            <br />
            <br />
            <b>Ta personnalité est-elle d’après toi un facteur de cohésion de ta communauté?</b>
            <br />C’est vachement mis en avant sur les réseaux sociaux et encore plus sur le streaming. Sur les streams tu as pas besoin d’être incroyable dans ta production, t’as pas besoin d’être un bon streameur. Mais ta personnalité est mise en avant et tu peux avoir une communauté qui te suis surtout pour ça. Instagram peut être moins mais sur Twitter j’ai l’impression que ça commence à être un plus ça aussi. Parce que les auteurs ne postent pas forcement que leurs dessins, ils postent tout.
            <br />
            <br />
            <b>Essaies tu de protéger ta vie privée?</b>
            <br />Ouais je fais attention à ça. Au fond ma véritable envie c’est d’être fou et de poster n’importe quoi sur Twitter mais j’ai trop peur d’avoir une sale image après! Mais dans le fond je pense que j’aimerais bien être juste ouvert avec les gens qui me suivent et leur montrer qui je suis vraiment.
            <br />
            <br />
            <b>De ce que j’ai vu, tu n’as pas trop cette habitude de t’utiliser toi comme un personnage, de partager tes opinions…</b>
            <br />Pas du tout ça me fait un peu peur, et j’ai pas envie qu’on me juge pour ça. Mais j’adore quand les artistes mettent autre chose que des dessins, qu’ils postent des trucs hyper intéressants. Il y a des gens qui te suivent parce qu’ils admirent qui tu es et pas juste parce qu’ils aiment bien tes dessins.
            <br />
            <br />
            <b>Comment tu gères ton temps entre ce qui relève de la communication et de la création ?</b>
            <br />C’est super dur ça je trouve. Moi je pense que ça devient le taf en soit de gérer la communication sur les réseaux sociaux. Pourtant il y a des auteurs qui ne gèrent pas du tout ça et ça marche super bien pour eux!
            <br />
            <br />
            <b>Dans ton cas tu penses que c’est nécessaire de communiquer sur les réseaux sociaux?</b>
            <br />Dans mon cas tous les tafs que j’ai eu c’était grâce aux réseaux sociaux. je suis mine de rien attaché à ma communauté donc j’ai envie d’entretenir ça et garder un contact avec eux. Puis quand tu les rencontres en vrai, que ce soit en dédicace ou à d’autres meet up, tu parais pas comme un inconnu. Pour ma part j’ai l’impression que c’est important en tout cas. Ça devrait pas l’être mais c’est devenu une sorte d’habitude.
            <br />
            <br />
            <b>J’ai l’impression que tu es plutôt stable au niveau de ta production de BD, tu es suivi par un éditeur, mais as-tu déjà pensé à faire un financement participatif?</b>
            <br />C’est une option que tu peux pas mettre de côté quand t’es auteur, t’es obligé d’y penser. Tu sais que maintenant c’est devenu une possibilité, je dis pas que c’est incontournable de le faire.
            <br />
            <br />
            <b>Si tu toi tu devais le faire ce serait pour un projet difficilement éditable?</b>
            <br />En fait j’ai un problème avec le crowfunding, c’est le fait d’être autre chose que auteur, c’est le travail qu’il y a autour. Je sais pas si j’en serai capable, si ça m’intéresserait. C’est vraiment compliqué et chronophage, tu peux pas faire ça à l’arrache. Ma passion elle est plus dans la narration et le dessin. Ça parait être tellement différent du travail d’auteur. Moi pour l’instant je suis satisfait d’avoir des éditeurs donc ça c’est cool. Si un jour j’ai l’occasion de faire un crowfunding je dirais pas non je pense.
            <br />
            <br />
            <b>Est ce que tes éditeurs comptent sur le fait que tu aies une communauté derrière toi pour la promotion de tes bandes dessinées?</b>
            <br />Ouais bien sûr. Ankama fait de toute manière sa promotion en grande partie sur les réseaux sociaux. Ils me le rappellent pas parce qu’il savent que je le fait.
            <br />
            <br />
            <br />
            <br />

            <h5 class="jaune">MIRION MALLE</h5>
            <br />
            <span class="bleu">Interview réalisée en avril 2019.</span>
            <br />
            <span
              class="text-danger"
            >/!\ Malheureusement j’ai raté l’enregistrement de l’interview. Vous allez donc lire les notes que j’ai prises suite à notre discussion. Désolée si des passages peuvent sembler imprécis. Snif.</span>
            <br />
            <br />Mirion malle a commencé à publier son travail sur internet juste après le bac. En publiant sur un forum de dessin, elle a pu communiquer avec d’autres artistes.
            <br />Elle a utilisé assez jeune internet (msn, skyblog,…)
            <br />Elle s’est vite intéressée aux blog BD et a décidé de lancer le sien, “Commando Culotte”.
            <br />Elle a bien vu le changement avec l’arrivée des des réseaux sociaux. Il y avait beaucoup moins de gens sur les blogs. Elle y trouvait les interactions plus intéressantes. Mirion malle a commencé à publier sur son blog mais elle est présente sur beaucoup d’autres plateformes. Elle aime beaucoup les blogs car il n’y pas de contraintes de format, de contenu,…
            <br />
            <br />( Alors que sur réseaux sociaux le format peut-être imposé, la visibilité réduite si les règles ne sont pas suivies )
            <br />Elle a lancé “Commando Culotte” quand elle était en prépa lettres, au début c’était surtout ses amis qui y lisaient son travail. Elle a fait des études théatrales après sa prépa. Elle l’a poursuivi une fois entrée à l’ESA saint Luc Bruxelles. Elle y postait à ce moment des travaux fait à l’école, des expérimentations de techniques… Dans ses dernières années d’études en bande dessinée, elle a commencé à faire ce qui ressemble le plus à son blog aujourd’hui : parler de films, de séries et de féminisme (elle en parlait déjà avant mais plus en pointillés). Elle s’est rendu compte que ce genre de billet suscitait beaucoup de réactions, de partages. C’était une voie qui l’intéressait donc elle a continué.
            <br />Internet lui a permis aussi de construire sa pensée féministe (suit féministes, militant.es sur internet.)
            <br />Mirion Malle a été contactée par deux éditeurs qui voulaient publier ses notes de blogs sur les films et séries. (Mais voulaient atténuer le propos féministe ou encore trouver autre personne pour le dessin car il ne leur plaisait pas). Puis elle a été contactée par Run ( ankama) qui lui a laissé carte blanche.
            <br />
            <br />Elle n’avait pas prévu que se soit publié au format papier. Elle ne pensait pas proposer ce travail à des éditeurs. ( Elle était encore en études à Saint Luc à ce moment là). Elle a fait ces BD pour les publier sur son blog, le fait que cela touche des lecteurs de cette manière lui suffisait. Ces BD didactiques étaient ainsi disponibles à la lecture gratuitement pour tous.
            <br />Mirion Malle a une approche “classique” de la bd sur son blog : elle dessine sur des feuilles puis les scanne et enfin les colorise sur ordinateur. Il est donc facile de passer du format numérique au format papier. (Pas comme Saturnome : tout son blog est adapté au format numérique.)
            <br />Avec ces notes, son lectorat s’est élargit. Ses BD ont été partagées et relayées par divers sites internet. Un public pas forcément lecteur de bandes dessinées, mais intéressé par ses propos à ainsi découvert son travail. (Sa note sur l’humour et les femmes a marqué un tournant)
            <br />Mirion Malle n’a jamais eu a faire de portfolio, tous ses contrats lui ont été proposés sur internet. Elle a ainsi réalisé des travaux d’illustation, des bd,… En ce moment elle publie aux éditions la ville brule, et est contente du travail réalisé avec cet éditeur.
            <br />Internet lui a permis de rencontrer beaucoup d’auteurs et d’autrices qui tenaient eux aussi un blog. (Tarmaz, Greoffroy monde,…) Des liens se sont ainsi créé entre eux, ils ont pu devenir amis, rencontrer de nouveaux artistes sur les festivals etc
            <br />Mirion Malle fait du fanzinat à côté, et participe à divers festivals de micro-édition pour les vendre. Elle possédait aussi une boutique en ligne. Elle y proposait ses fanzine et des originaux d’illustrations.
            <br />
            <br />L’ humour est très présent dans son travail et fait partie de sa personnalité.
            <br />Mirion Malle n’a pas cherché à se créer un personnage différent de sa personnalité pour se présenter sur son blog et les réseaux sociaux.
            <br />Elle a l’habitude de se représenter dans son blog donc cela s’est fait de manière naturelle.
            <br />Même si le contenu qu’elle partage peut sembler spontané, c’est quand même réfléchi. (Dans les stories Instagram, elle publie des vidéos de ukulélé, des photos du quotidien avec la plupart du temps un note d’humour). Elle ne partage pas de moments très intimes afin de protéger malgré tout sa vie privée.
            En fonction des platefomes, elle sent une différence de public : sur Twitter les gens la suivent pour ses propos féministes en autres.
            <br />Instagram est plus réservé à sa pratique du dessin. Son aspect est professionnel car il se présente comme un portfolio.
            <br />Comme son travail est engagé, Mirion Malle fait régulièrement face à des trolls et des masculinistes. Quand une vague de messages négatifs arrive, elle passe son Twitter en privé en attendant que la situation se calme. Elle a décidé de les ignorer : leur répondre ne sert à rien car ils ne sont pas prêt à changer d’avis, et les bloquer les enflamme. Cette solution lui plait moyennement car cela fait partie de son job de communiquer sur réseaux. “En ce moment on me dit juste que mes dessins sont moches donc ça va”
            <br />
            <br />Comme elle fait de la BD le harcèlement sur internet est à moindre échelle par rapport à des youtubeuses féministes. Mais elle y a quand même affaire. Quand elle publie une BD (même au format papier), elle s’attend à avoir des retours sur les réseaux sociaux négatifs comme positifs.
            <br />Les retours sont majoritairement positifs et encourageants quand même.
            <br />Elle s’est rendue compte que des gens cherchaient des photos d’elle sur internet. Pour éviter que tombent sur photos elle ado quelle aurait oublié d’enlever, elle a décidé de mettre plus de photos d’elle.
            <br />Mirion Malle a du mal à parler de communauté pour les gens qui la suivent.
            <br />Il y a tout de même des gens qui reviennent, qui envoient messages.
            <br />
            <br />
            <br />
            <br />

            <h5 class="jaune">AERINN</h5>
            <br />
            <span class="bleu">Interview réalisée en Mars 2019</span>
            <br />

            <b>As-tu fait des études artistiques?</b>
            <br />Je me suis inscrite à l’académie des Beaux arts de Tournai en me disant que j’apprendrai un sacré paquet de choses, que je ferai du concret… mais j’ai été très déçue par la qualité de l’enseignement donné sur la BD elle-même, et sur tous les cours qui n’avaient pas réellement de rapport avec la BD.
            Je me suis aperçue que j’apprenais bien plus grâce au fanzinat, et sans me ruiner. J’avais pris l’habitude de m’organiser et d’être autonome…J’ai donc appris en autodidacte tout en faisant un boulot alimentaire à côté.
            <br />C’est mon expérience personnelle : pour d’autres l’école sera plus adaptée. Je ne crois pas qu’il y ait de mauvais choix, c’est vraiment selon notre façon de faire ! J’ai toujours été quelqu’un d’assez indépendant donc je crois que l’école ce n’était pas pour moi.
            <br />Je pense que l’école et l’apprentissage en autodidacte ont tous deux des avantages et inconvénients. A chacun de choisir ce qui lui parait le mieux!
            Quand as-tu commencé à publier sérieusement ton travail sur internet et pourquoi? Sur quelle(s) plateforme(s) as-tu commencé? (blog, Facebook,tumblr,…)
            J’ai commencé à publier sur Internet avec le fanzine collectif que j’avais créé : Shinokami. On publiait nos Bds sur notre site en essayant d’être réguliers ^^Mais on ne faisait que très peu de vues. (nb : Le fanzine à reçu le prix du meilleur fanzine de la Japan Touch en 2008, puis Japan Expo en 2009 et 2013). C’est seulement avec Chronoctis Express début 2014 que je me suis lancée dans le webcomic pur et dur, après a avoir vu que les auteurs pouvaient se faire remarquer par les éditeurs de cette façon. Mon objectif étant d’être publiée, j’ai posté sur Amilova, puis feu Ink Blazers en anglais, Mangadraft, Tapas, et enfin Line Webtoon.
            <br />Je publie aussi sur mon site mais c’est clairement sur les plateformes de BD indépendantes qu’on se fait remarquer.
            <br />
            <br />
            <b>As-tu dès le début publié tes bandes-dessinées ou était-ce un autre type de contenu?</b>
            <br />J’ai directement publié mes BDs oui, les illustrations c’est venu plus tard.
            <br />
            <br />
            <b>Dès ton enfance/adolescence, étais tu déjà présente sur internet ? (par exemple pour lire des blogs bd, participer à des forums…)</b>
            <br />Internet pour tous est apparu quand j’avais 13 ans, mais je n’y ai eu accès qu’à partir de l’âge de 20 ans.
            <br />
            <br />
            <b>Est ce que pour toi, avoir un contact régulier avec tes lecteurs à toujours eu beaucoup d’importance?</b>
            Avoir un contact régulier avec mes lecteurs a toujours été important oui, notamment parce que mes proches ne s’intéressent pas particulièrement à mes créations, je n’ai pas de recul sur ce que je fais. Et comme beaucoup d’autrices, je manque cruellement de confiance en moi et ai tendance à rabaisser mon travail. Les commentaires bienveillants des lecteurs m’aident à garder le cap, c’est mon carburant haha ^^
            <br />
            <br />
            <b>Y a t-il une ou des plateformes sur lesquelles tu développes un véritable échange avec tes lecteurs?</b>
            <br />Amilova est une plateforme où j’ai un vrai échange avec les lecteurs. Mais j’avoue que depuis que je publie mon livre en version papier, beaucoup de lecteurs ont cessé de lire mes pages pour attendre la sortie du prochain tome, et je n’ai plus autant de retours qu’avant, à mon grand regret !
            Aujourd’hui tu es présente sur de très nombreuses plateformes, comment gères-tu ton temps de travail entre la création et la communication?
            On a tendance à vite se laisser engloutir par les réseaux sociaux, par les commentaires, les messages des gens. Jusqu’à il y a peu je me fixais de répondre à tout le monde, mais c’est une erreur, c’est contre-productif!
            <br />Si on passe son temps à communiquer, on n’avance plus nos BDs.
            <br />Un auteur doit savoir être parfaitement organisé et s’en tenir à un planning.
            <br />Par exemple, tous les lundis matin, tu programmes toutes les news de la semaine avec une plateforme comme Hootsuite. Tu te fixes 30min à 1h par jour pour toute la communication, de préférence - en ce qui me concerne - quand toutes les tâches importantes de la journée ont été faites. C’est à dire le soir ^^
            <br />
            <br />
            <b>Pendant les festivals de BD est-ce que tu rencontres majoritairement des lecteurs qui connaissent déjà bien ton travail via internet ou est-ce que tu touches un nouveau public (ou bien les deux)?</b>
            Pendant les festivals de BD, le type de public dépend de la situation. Si c’est un festival que j’ai déjà fait, si j’ai un nouveau tome qui vient de sortir, les habitués seront là.
            <br />Si c’est un festival nouveau, ou si je n’ai pas de nouveauté, il y aura plus de nouveaux lecteurs.
            <br />Mais globalement ça reste quand même très diversifié, j’ai beaucoup de nouveaux lecteurs et beaucoup d’anciens, j’ai aussi des anciens qui ramènent leurs amis, qui du coup se procurent mes tomes aussi :D
            <br />
            <br />
            <b>Dans quelle mesure internet t’as permis d’entrer en contact avec des auteurs et autrices de BD? Avais tu déjà pour habitude d’en rencontrer sur les festivals?</b>
            <br />Les auteurs se BD je les ais tous rencontrés en festival. Même si on se connaissait de nom sur internet, les échanges ne se sont faits qu’une fois qu’on a fait connaissance face à face ^^
            <br />Il n’a que quand j’ai été invitée à un live sur Twitch avec d’autres auteurs, 2 fois, que j’ai fait connaissance mais sinon c’est toujours lors de rencontres.
            <br />
            <br />
            <b>Quels sont les facteurs qui t’ont fait sentir prête à lancer ta campagne ulule pour le tome 1 de Chronoctis Express?</b>
            <br />Pour la campagne Ulule, c’est la rage d’avoir été ignorée des éditeurs malgré une bonne communauté qui m’a fait passer à l’action haha
            Je gérais un fanzine depuis des années, j’avais l’habitude des festivals, je me suis dit que m’autoéditer ne serait pas si différent. Je voulais un format traditionnel manga avec jaquette, et pour ça j’étais obligée de passer par un imprimeur pour professionnels qui demandait un minimum de 1000 impressions.
            <br />Ulule s’est vite imposé comme la solution, et j’ai pensé que ce serait une bonne façon de voir si les gens étaient vraiment intéressés par l’histoire.
            <br />
            <br />
            <b>Qu’est ce qu’est pour toi une communauté de lecteurs ?</b>
            <br />Pour moi, une communauté de lecteurs, ce sont des lecteurs qui quoi qu’il arrive te soutiennent, qui seront présents à la sortie de chaque tome, ou t’encouragent par des messages bienveillants, te soutiennent sur Tipeee, parlent de ta bd à leurs proches ou leurs propres communautés… bref, ce sont les personnes qui s’intéressent positivement à ce que tu fais ^^
            <br />
            <br />
            <b>Essayes tu de préserver dans la mesure du possible ta vie privée en faisant attention à ce que tu partages avec tes lecteurs? Ou au contraire, parler de ta vie quotidienne, partager tes opinions fait partie de ta démarche ? T’es tu créé un identité spécifique en ligne ? (Utilises tu ton identité comme un “personnage” par exemple)</b>
            <br />Je fais effectivement attention à ne pas mélanger privée et publique. Les gens me suivent pour ce que je fais, savoir ce que j’ai mangé, que je me suis cassé la figure dans les escaliers ou le dernier film que j’ai regardé n’a aucun lien avec Chronoctis Express. Je ne poste des choses sur moi que quand ça a un lien direct avec mes créations.
            <br />Je n’ai pas créé d’entité personnage non. Je fais de la fiction donc en théorie les gens n’ont pas à s’intéresser à moi en tant que personne ou personnage, je veux qu’on se focalise sur mes BDs ^^ Contrairement aux auteurs issus de la vague blog Bd, comme Boulet, Maliki, etc… qui eux sont à la fois auteurs et personnages principaux de leurs Bds.
            <br />
            <br />
            <b>Est ce que tu penses que que ta personnalité, ton identité en tant qu’autrice est un facteur de cohésion de ta communauté?</b>
            <br />Je ne crois pas que mon identité soit un facteur de cohésion pour ma communauté. Je pense que mon caractère a par contre une influence. Comme j’essaye d’être souriante et accessible et que je suis reconnaissante, j’ai remarqué que mes lecteurs y sont sensibles et ont tendance à plus facilement me soutenir. C’est plus facile de s’investir dans une œuvre quand on apprécie l’auteur ^^
            <br />Moi même je soutiens très fort les auteurs que je trouve super adorables, tandis qu’il m’est arrivé d’arrêter de suivre des artistes parce que leurs messages sur internet n’étaient que haine et plaintes. Personne n’aime côtoyer des proches qui se plaignent tout le temps de tout, et ça vaut aussi pour les artistes qu’on suit !
            <br />
            <br />
            <b>Si tu devais citer les 3 plus gros avantages de l’autoédition et les 3 plus gros inconvénients, quels seraient t-ils ?</b>
            <br />L’auto édition, c’est la liberté de création, de pouvoir gérer notre temps à notre rythme, de laisser le temps à nos créations de faire leurs preuves (contrairement aux quelques jours d’existence dans les librairies). Et on gagne beaucoup plus d’argent pour beaucoup moins de livres vendus. Vivre de son art est donc plus accessible parce qu’on n’a pas besoin de vendre 3,000 livres par mois, mais plutôt 300 par mois pour gagner un bon SMIC.
            Mais c’est aussi chronophage (on gère seul plusieurs métiers), du coup ça demande énormément de compétence et d’organisation, plus qu’un auteur édité. Et on est plus isolé (pas d’éditeur pour t’orienter, te rassurer, donner son point de vue…) , donc plus facilement en proie au doute. Cela dit je préfère largement l’autoédition. La liberté ça n’a pas de prix!
            <br />
            <br />
            <b>Est ce que tu as l’impression que les gens font la différence entre une BD auto-éditée et BD publiée par un éditeur? Ou bien tant que la qualité est au rendez-vous, les deux jouissent du même statut de BD professionnelles?</b>
            <br />Je ne saurais dire globalement comment ça se passe pour les autres, mais pour ma part les gens qui viennent me trouver en festival n’ont pas l’air de faire la distinction, tout du moins pas sur la qualité. La seule chose sur laquelle ils sont parfois un peu inquiets et qu’ils me posent des questions, c’est savoir si ce sera facile pour eux de se procurer la suite, et si j’ai l’intention d’aller jusqu’au bout de la série! Mais sinon j’ai l’impression que les gens qui viennent me trouver sont même plutôt enthousiastes à l’idée de soutenir un auteur indépendant et découvrir son travail. Comme il n’y a pas d’intermédiaire, ils savent qu’ils te soutiennent directement (comme quand tu achètes tes légumes directement auprès du producteur au marché ^^) Je me rappelle d’un festival où je dédicaçais mon propre tome 1 auto-édité, et le tome 1 version éditeur. Tout le monde ne prenait que la version auto-éditée parce qu’ils ne voulaient donner l’argent qu’à moi XD
            <br />Par contre quand il s’agit des libraires, là ils font clairement une différence et considèrent l’auto-édition comme quelque chose de pas sérieux. Pour eux, si on n’est pas édité, c’est que ce qu’on fait n’a pas de valeur.
            <br />J’ai essayé de travailler avec des libraires, mais à part une minorité, la plupart m’ont littéralement snobée XD Quand on fait de l’auto-édition il faut se concentrer sur le circuit court : on vend sur notre boutique en ligne, sur Ulule, en festivals, etc… Les libraires ne valent le coup que si ce sont eux qui viennent vers toi et qu’ils t’achètent au moins 10 exemplaires d’un coup, sinon ça ne rapporte rien (ils prennent 35 à 45% sur la vente) et tu passes trop de temps à préparer la commande, l’envoyer, faire la facture, etc…
            <br />
            <br />
            <b>Est ce que tu penses que faire du manga t’apporte un public avec des habitudes différentes des lecteurs familiers des BD franco-belges par exemple ? Je suppose que tu as un public relativement jeune et donc plus investi sur internet, et parfois habitué aux évènement"geeks" existants.</b>
            <br />Pour le public de Chonoctis Express, j’ai effectivement pu remarquer une petite différence avec le public franco-belge. Dans les festivals franco-belge je vois plus de chasseurs de dédicaces, et j’ai régulièrement des parents ou grands parents qui viennent acheter des mangas pour leurs enfants/petits enfants. Du coup ces gens sont parfois un peu plus agressifs parce qu’ils ne s’intéressent pas à ton travail, ils sont là en tant qu’intermédiaires. Les seules fois où les gens se sont énervés sur moi (parce que je partais manger à midi et que ça les obligeait à revenir à partir de 14h) c’était dans des festivals franco-belge. Ils sont aussi plus exigeants sur les dédicaces :P
            <br />Côté festival de manga, les gens sont plus portés sur l’échange, certains ne me demandent même pas de dédicace (j’avoue que je n’aime pas en faire donc ça m’arrange !), puis bon… forcément, on partage beaucoup plus de choses en commun, on va parler des derniers mangas sortis, de jeux vidéo, d’animes, de dramas… Dans les festivals manga j’ai l’impression qu’on est tous comme une grande famille, j’aime beaucoup l’ambiance!
            <br />Par contre, les festivals mangas… en fait, je devrais plutôt dire festivals geeks, ont un public beaucoup plus hétérogène que les festivals franco-belge. Beaucoup de visiteurs sont là pour voir leurs youtubeurs préférés, acteurs, chanteurs, joueurs de jeux vidéo pros, réalisateurs d’animes, etc… Et je me suis aperçue que les auteurs de manga français étaient un peu invisibles. Je pense que c’est en partie la faute des organisateurs qui nous considèrent comme les invités les moins importants (si tu es auto-édité c’est encore pire, tu ne seras pas invité et sera mis dans un coin du festival après avoir payé ton hotel, ton stand et ton transport !) J’ai clairement vu la différence dans la façon de s’occuper des invités. Par exemple, certains festivals mettent les youtubeurs dans des hotels plus chics, des restos plus classes, on met à leur disposition des navettes perso pour faire l’aller-retour entre hotel-resto-festival…
            <br />Tandis que les festivals franco-belge auront beaucoup plus de respect pour toi, car ce sont des festivals uniquement dédiés à la rencontre entre auteurs et lecteurs. On est respectés, mis en valeur, ça fait du bien ^^
            <br />Et j’ai absolument tous les âges, c’est très surprenant ! ça va de 12 ans, à des gens à la retraite ^^ Et autant de garçons que de filles. Après bien sûr, le plus gros de mes lecteurs reste quand même les jeunes, je dirais entre 13 et 35 ans. Les lecteurs franco-belges viennent aussi plus facilement vers moi que sur d’autres mangas français, parce que la lecture se fait de gauche à droite. Régulièrement en festival, des lecteurs me disent découvrir le manga avec ma série (ça fait super plaisir XD)
            <br />Là où je pense qu’il y a une différence par rapport aux lecteurs de manga, c’est que ceux qui viennent me trouver font preuve d’une certaine ouverture d’esprit, ce n’est pas tout le monde qui vient me voir. Déjà parce que je suis auto-éditée, mais aussi et surtout parce que je suis française, donc pas japonaise. Là-dessus la plupart des ados restent encore très fermés, d’autant plus avec le sens de lecture à la française (ils n’ont pas connu l’époque où tous les mangas japonais étaient retournés pour être dans le sens français haha ! Toutes mes premières séries sont dans le sens français : Dragon Ball, Ranma 1/2, Sakura, le début de One Piece, Kenshin… ma génération est du coup super ouverte sur le sens de lecture, on ne me demande jamais pourquoi j’ai choisi le sens français. J’ai remarqué cela dit qu’il y a de plus en plus d’ouverture même chez les ados. Je pense que le fait qu’il y ait de plus en plus de mangas français de très bonne qualité aide à ce que les lecteurs changent d’avis sur les productions de chez nous, c’est super cool ^^ D’ici quelques années le manga français sera certainement quelque chose de normal chez tout le monde :D
            <br />
          </span>
          <hr />
          <h4 class="bleu mt-5">Sondage :</h4>
        </div>
        <div class="col-8">
          <img src="./assets/img/sondage.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  methods: {
    grandun() {
      window.scrollTo(0, window.innerHeight * 7.67613038906);
    },
    aun() {
      window.scrollTo(0, window.innerHeight * 10.4100946372);
    },
    bun() {
      window.scrollTo(0, window.innerHeight * 12.61829653);
    },
    cun() {
      window.scrollTo(0, window.innerHeight * 14.1955835962);
    },
    grandde() {
      window.scrollTo(0, window.innerHeight * 17.1398527865);
    },
    ade() {
      window.scrollTo(0, window.innerHeight * 17.5604626709);
    },
    bde() {
      window.scrollTo(0, window.innerHeight * 19.3480546793);
    },
    cde() {
      window.scrollTo(0, window.innerHeight * 22.3974763407);
    },
    unde() {
      window.scrollTo(0, window.innerHeight * 22.7655099895);
    },
    dede() {
      window.scrollTo(0, window.innerHeight * 26.2881177708);
    },
    troide() {
      window.scrollTo(0, window.innerHeight * 30.5467928496);
    },
    grandtroi() {
      window.scrollTo(0, window.innerHeight * 34.9106203996);
    },
    atroi() {
      window.scrollTo(0, window.innerHeight * 35.7518401682);
    },
    btroi() {
      window.scrollTo(0, window.innerHeight * 45.0578338591);
    },
    ctroi() {
      window.scrollTo(0, window.innerHeight * 46.792849632);
    },
    conclu() {
      window.scrollTo(0, window.innerHeight * 48.6330178759);
    },
    biblio() {
      window.scrollTo(0, window.innerHeight * 57.0977917981);
    },
    annexes() {
      window.scrollTo(0, window.innerHeight *  63.0914826498);
    },

    pinContainerScene() {
      const tl = new this.$gsap.TimelineMax();
      var Length = 5;

      tl.add([
        TweenMax.fromTo(
          `div.protecc`,
          0.000001,
          { zIndex: 49, opacity: 1 },
          {
            opacity: 1,
            zIndex: 49
          }
        ),
        TweenMax.fromTo(
          `div.chunk1`,
          1,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-70%",
            ease: Linear.easeNone
          }
        ),
        TweenMax.fromTo(
          `div.chunk2`,
          1,
          { y: "100%", opacity: 1 },
          {
            opacity: 1,
            y: "60%",
            ease: Linear.easeNone
          }
        )
      ]);
      tl.fromTo(
        `img.mintro`,
        0.2,
        { x: "100%", opacity: 0 },
        {
          opacity: 1,
          x: "0%",
          ease: Linear.easeNone
        }
      ),
        tl.fromTo(
          `img.imgintro`,
          0.2,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.chunk1`,
            0.5,
            { y: "-70%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk2`,
            0.5,
            { y: "60%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]);
      tl.fromTo(
        `div.bulle1`,
        0.1,
        { x: "0%", opacity: 0 },
        {
          opacity: 1,
          x: "0%",
          ease: Linear.easeNone
        }
      ),
        tl.fromTo(
          `div.chunk2`,
          0.2,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-35%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle2`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 49, opacity: 1 },
            {
              opacity: 1,
              zIndex: 48
            }
          ),
          TweenMax.fromTo(
            `div.chunk2`,
            0.3,
            { y: "-35%", opacity: 1 },
            {
              opacity: 1,
              y: "-90%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk3`,
            0.3,
            { y: "100%", opacity: 1 },
            {
              opacity: 1,
              y: "10%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.graph`,
          0.2,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.chunk2`,
            0.1,
            { y: "-90%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk3`,
            0.1,
            { y: "10%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.chunk3`,
          0.3,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-35%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 48, opacity: 1 },
            {
              opacity: 1,
              zIndex: 47
            }
          ),
          TweenMax.fromTo(
            `div.chunk3`,
            0.3,
            { y: "-35%", opacity: 1 },
            {
              opacity: 1,
              y: "-75%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk4`,
            0.3,
            { y: "100%", opacity: 1 },
            {
              opacity: 1,
              y: "20%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `img.fanny1`,
          0.3,
          { maxWidth: "0%", opacity: 0 },
          {
            opacity: 1,
            maxWidth: "100%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `img.partie1`,
          0.1,
          { opacity: 0 },
          {
            opacity: 1,
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.chunk3`,
            0.2,
            { y: "-75%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk4`,
            0.2,
            { y: "20%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.chunk4`,
          0.5,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-58%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 47, opacity: 1 },
            {
              opacity: 1,
              zIndex: 46
            }
          ),
          TweenMax.fromTo(
            `div.chunk4`,
            0.5,
            { y: "-58%", opacity: 1 },
            {
              opacity: 1,
              y: "-90%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk5`,
            0.5,
            { y: "52%", opacity: 1 },
            {
              opacity: 1,
              y: "12%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.bulle3`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.chunk4`,
            0.2,
            { y: "-90%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk5`,
            0.2,
            { y: "12%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.bulle4`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 46, opacity: 1 },
            {
              opacity: 1,
              zIndex: 45
            }
          ),
          TweenMax.fromTo(
            `div.chunk5`,
            0.5,
            { y: "0%", opacity: 1 },
            {
              opacity: 1,
              y: "-55%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.add([
          TweenMax.fromTo(
            `div.chunk5`,
            0.5,
            { y: "-55%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk6`,
            0.5,
            { y: "70%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.bulle5`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.chunk6`,
          0.2,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-30%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle6`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 45, opacity: 1 },
            {
              opacity: 1,
              zIndex: 44
            }
          ),
          TweenMax.fromTo(
            `div.chunk6`,
            0.5,
            { y: "-30%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk7`,
            0.5,
            { y: "44%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.chunk7`,
          0.5,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-55%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 44, opacity: 1 },
            {
              opacity: 1,
              zIndex: 43
            }
          ),
          TweenMax.fromTo(
            `div.chunk7`,
            0.5,
            { y: "-55%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk8`,
            0.5,
            { y: "55%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `img.jeanmi1`,
          0.3,
          { maxWidth: "0%", opacity: 0 },
          {
            opacity: 1,
            maxWidth: "100%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `img.partie2`,
          0.1,
          { opacity: 0 },
          {
            opacity: 1,
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle7`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.chunk8`,
          0.3,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-45%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `img.roz`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `img.jau`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `img.ble`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `img.oran`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 43, opacity: 1 },
            {
              opacity: 1,
              zIndex: 42
            }
          ),
          TweenMax.fromTo(
            `div.chunk8`,
            0.4,
            { y: "-45%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk9`,
            0.4,
            { y: "35%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.chunk9`,
          0.7,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-70%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 42, opacity: 1 },
            {
              opacity: 1,
              zIndex: 41
            }
          ),
          TweenMax.fromTo(
            `div.chunk9`,
            0.3,
            { y: "-70%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk10`,
            0.3,
            { y: "65%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.chunk10`,
          0.2,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-35%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle8`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 41, opacity: 1 },
            {
              opacity: 1,
              zIndex: 40
            }
          ),
          TweenMax.fromTo(
            `div.chunk10`,
            0.3,
            { y: "-35%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk11`,
            0.3,
            { y: "40%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.chunk11`,
          0.5,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-63%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 40, opacity: 1 },
            {
              opacity: 1,
              zIndex: 39
            }
          ),
          TweenMax.fromTo(
            `div.chunk11`,
            0.5,
            { y: "-63%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk12`,
            0.5,
            { y: "40%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.bulle9`,
          0.05,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.chunk12`,
          0.5,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-60%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 39, opacity: 1 },
            {
              opacity: 1,
              zIndex: 38
            }
          ),
          TweenMax.fromTo(
            `div.chunk12`,
            0.5,
            { y: "-60%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk13`,
            0.5,
            { y: "50%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.chunk13`,
          0.2,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-30%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle10`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle11`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.chunk13`,
          0.5,
          { y: "-30%", opacity: 1 },
          {
            opacity: 1,
            y: "-62%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 38, opacity: 1 },
            {
              opacity: 1,
              zIndex: 37
            }
          ),
          TweenMax.fromTo(
            `div.chunk13`,
            0.5,
            { y: "-62%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk14`,
            0.5,
            { y: "50%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.bulle12`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle13`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.chunk14`,
          0.5,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-45%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 37, opacity: 1 },
            {
              opacity: 1,
              zIndex: 36
            }
          ),
          TweenMax.fromTo(
            `div.chunk14`,
            0.5,
            { y: "-45%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk15`,
            0.5,
            { y: "40%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.bulle14`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.chunk15`,
          0.8,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-66%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle15`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle16`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 36, opacity: 1 },
            {
              opacity: 1,
              zIndex: 35
            }
          ),
          TweenMax.fromTo(
            `div.chunk15`,
            0.5,
            { y: "-66%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk16`,
            0.5,
            { y: "20%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `img.poing`,
          0.1,
          { maxWidth: "60%", opacity: 1, left: "15%", bottom: "5%" },
          {
            opacity: 1,
            maxWidth: "150%",
            left: "-50%",
            bottom: "-50%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `img.partie3`,
          0.1,
          { opacity: 0 },
          {
            opacity: 1,
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.chunk16`,
          4.5,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-83%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 35, opacity: 1 },
            {
              opacity: 1,
              zIndex: 34
            }
          ),
          TweenMax.fromTo(
            `div.chunk16`,
            0.8,
            { y: "-83%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk17`,
            0.8,
            { y: "50%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.bulle17`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.chunk17`,
          0.5,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-30%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.bulle18`,
          0.1,
          { x: "0%", opacity: 0 },
          {
            opacity: 1,
            x: "0%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.chunk17`,
          0.5,
          { y: "-30%", opacity: 1 },
          {
            opacity: 1,
            y: "-60%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 34, opacity: 1 },
            {
              opacity: 1,
              zIndex: 33
            }
          ),
          TweenMax.fromTo(
            `div.chunk17`,
            0.6,
            { y: "-60%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk18`,
            0.6,
            { y: "35%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.chunk18`,
          3.5,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-68%",
            ease: Linear.easeNone
          }
        ),
        tl.add([
          TweenMax.fromTo(
            `div.protecc`,
            0.000001,
            { zIndex: 33, opacity: 1 },
            {
              opacity: 1,
              zIndex: 32
            }
          ),
          TweenMax.fromTo(
            `div.chunk18`,
            1,
            { y: "-68%", opacity: 1 },
            {
              opacity: 1,
              y: "-100%",
              ease: Linear.easeNone
            }
          ),
          TweenMax.fromTo(
            `div.chunk19`,
            1,
            { y: "6.5%", opacity: 1 },
            {
              opacity: 1,
              y: "0%",
              ease: Linear.easeNone
            }
          )
        ]),
        tl.fromTo(
          `div.chunk19`,
          35,
          { y: "0%", opacity: 1 },
          {
            opacity: 1,
            y: "-100%",
            ease: Linear.easeNone
          }
        ),
        tl.fromTo(
          `div.protecc`,
          0.000001,
          { zIndex: 32, opacity: 1 },
          {
            opacity: 1,
            zIndex: 32
          }
        );
      tl.fromTo(
        `div.chunk1`,
        0.0000001,
        { y: "0%", opacity: 1 },
        {
          opacity: 1,
          y: "0%"
        }
      ),
        tl.fromTo(
          `div.protecc`,
          0.000001,
          { zIndex: 49, opacity: 1 },
          {
            opacity: 1,
            zIndex: 49
          }
        );

      const scene = new this.$scrollmagic.Scene({
        triggerElement: ".pin",
        triggerHook: "onLeave",
        duration: `${Length * 2500}%`
      })
        .setPin(".pin")
        .setTween(tl);

      this.$ksvuescr.$emit("addScene", "pinContainerScene", scene);
    }
  },
  destroyed() {
    this.$ksvuescr.$emit("destroy");
  },
  mounted() {
    this.$nextTick(this.pinContainerScene);
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 1px;
  overflow-x: hidden;
  position: relative;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
  border-bottom: 1px solid #42b983;
}
</style>



// WEBPACK FOOTER //
// src/App.vue